import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import SosialUgc from '../components/SosialUgc'; // video panjang → TikTok/Instagram (2026-10-26)
import { useNavigate } from 'react-router-dom';
import AiGeneratorPanel from '../components/AiGeneratorPanel';
import CampaignPicker, { matchCampaign } from '../components/CampaignPicker';
import { useAuth } from '../context/AuthContext';
import UgcUploadJadi from '../components/UgcUploadJadi';
import JadwalKirim from '../components/JadwalKirim';

const API = process.env.REACT_APP_API_URL;

const STATUS_LABEL = {
  draft: 'Draft', processing: 'Memproses...', ready: 'Siap Preview',
  distributing: 'Sedang Upload ke Channel', done: 'Selesai', failed: 'Gagal'
};
const STATUS_COLOR = {
  draft: '#6B7280', processing: '#D97706', ready: '#059669',
  distributing: '#C2410C', done: '#047857', failed: '#DC2626'
};
const CHANNEL_STATUS_LABEL = {
  pending: 'Menunggu dipilih', scheduled: 'Terjadwal', uploading: 'Sedang upload...',
  done: 'Berhasil', failed: 'Gagal'
};
const CHANNEL_STATUS_COLOR = {
  pending: '#6B7280', scheduled: '#6B7280', uploading: '#D97706', done: '#059669', failed: '#DC2626'
};

function hdr() {
  return { headers: { Authorization: `Bearer ${localStorage.getItem('sm_token')}` } };
}

export default function Ugc() {
  const { client: fiturKlien } = useAuth(); // fitur rinci (2026-10-25): hanya untuk menyembunyikan Upload video jadi
  const [projects, setProjects] = useState([]);
  // Proyek yang dibuka lagi setelah kembali dari editor tampilan (dititip Dashboard.js).
  const [selected, setSelected] = useState(() => {
    try { const v = localStorage.getItem('ugc_open_project'); localStorage.removeItem('ugc_open_project'); return v || null; } catch (e) { return null; }
  });
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');
  const [creating, setCreating] = useState(false);
  const [title, setTitle] = useState('');
  const [visualMode, setVisualMode] = useState('still');
  const [visualSource, setVisualSource] = useState('template');
  const [bgTemplate, setBgTemplate] = useState('');
  const [motionLayer, setMotionLayer] = useState('none');
  const [postEffect, setPostEffect] = useState('none');
  const [templates, setTemplates] = useState({ backgrounds: [], motionLayers: [] });
  // DNA Channel (2026-10-07): opsional, mengarahkan gaya judul & deskripsi AI proyek ini.
  const [dnaList, setDnaList] = useState([]);
  const [dnaId, setDnaId] = useState('');
  useEffect(() => { load(); loadTemplates(); loadDna(); }, []);
  async function loadDna() {
    try {
      const r = await axios.get(`${API}/api/dna`, hdr());
      const ready = (r.data || []).filter(d => d.status === 'ready');
      setDnaList(ready);
      // Tombol "Pakai di proyek UGC baru" di halaman DNA Channel menitipkan id DNA di sini.
      let pre = null;
      try { pre = localStorage.getItem('ugc_preselect_dna'); localStorage.removeItem('ugc_preselect_dna'); } catch (e) {}
      if (pre && ready.some(d => d.id === pre)) setDnaId(pre);
    } catch (e) { /* fitur opsional — form tetap jalan tanpa daftar DNA */ }
  }
  async function loadTemplates() {
    try {
      const r = await axios.get(`${API}/api/ugc/templates`, hdr());
      setTemplates(r.data);
      if (r.data.backgrounds && r.data.backgrounds.length > 0) setBgTemplate(r.data.backgrounds[0].file);
    } catch (e) { console.error('load templates', e); }
  }

  // pesan untuk proyek yang baru dibuka (mis. hasil "Buat lagi", atau dari Trending lewat Dashboard.js)
  const [flash, setFlash] = useState(() => {
    try { const v = localStorage.getItem('ugc_open_note'); localStorage.removeItem('ugc_open_note'); return v || ''; } catch (e) { return ''; }
  });
  async function load() {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/api/ugc/projects`, hdr());
      setProjects(r.data);
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal memuat proyek');
    }
    setLoading(false);
  }

  async function createProject() {
    setCreating(true);
    try {
      const r = await axios.post(`${API}/api/ugc/projects`,
        { title: title.trim() || null, bg_template: bgTemplate, motion_layer: motionLayer, post_effect: 'none', dna_id: dnaId || null }, hdr());
      setSelected(r.data.id);
      load();
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal membuat proyek');
    }
    setCreating(false);
  }

  if (selected) {
    return <UgcDetail projectId={selected} flash={flash} onOpen={(id, note) => { setFlash(note || ''); setSelected(id); }} onBack={() => { setFlash(''); setSelected(null); load(); }} />;
  }

  return (
    <div>
      <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 6 }}>UGC Compilation</h1>
      <p style={{ color: '#6B7280', fontSize: 14, marginBottom: 24 }}>
        Buat video kompilasi lagu panjang dari katalog kamu — otomatis dijahit, dikasih visual, dan dijadwalkan ke channel YouTube.
      </p>

      {msg && (
        <div style={{ padding: '10px 16px', marginBottom: 18, borderRadius: 12,
          background: '#FEF2F2', color: '#DC2626',
          border: '1px solid #FCA5A5', fontSize: 14 }}>{msg}</div>
      )}

      <div style={{ background: '#F3F4F6', padding: 18, borderRadius: 14, marginBottom: 24 }}>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>Proyek Baru</div>
        <div style={{ marginBottom: 12 }}>
          <input type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="Nama proyek (contoh: Kompilasi Lagu Dangdut September)"
            style={{ width: '100%', maxWidth: 420, padding: '9px 12px', borderRadius: 8, boxSizing: 'border-box' }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          {dnaList.length > 0 ? (
            <>
              <label htmlFor="ugc-dna" style={{ display: 'block', fontSize: 12, color: '#6B7280', marginBottom: 6 }}>Gaya judul &amp; deskripsi (opsional)</label>
              <select id="ugc-dna" value={dnaId} onChange={e => setDnaId(e.target.value)}
                style={{ width: '100%', maxWidth: 420, padding: '9px 12px', borderRadius: 8, boxSizing: 'border-box' }}>
                <option value="">Standar (tanpa DNA)</option>
                {dnaList.map(d => <option key={d.id} value={d.id}>Ikuti DNA: {d.channel_name || d.channel_url}</option>)}
              </select>
            </>
          ) : (
            <div style={{ fontSize: 12, color: '#6B7280' }}>Mau judul mengikuti pola channel yang sedang naik? Tambahkan channel acuan di menu DNA Channel.</div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center', marginBottom: 10 }}>
          <button className="btn btn-gold" disabled={creating} onClick={createProject}>
            {creating ? '...' : '+ Buat Proyek'}
          </button>
        </div>
        <div style={{ fontSize: 11, color: '#6B7280' }}>Latar bawaan, lapisan efek (overlay), font, dan posisi teks diatur di editor tampilan setelah lagu dimasukkan.</div>
      </div>

      {fiturKlien?.features?.ugc_upload !== false && <UgcUploadJadi onDone={id => { setSelected(id); load(); }} />}

      {loading ? (
        <div className="loading"><div className="spinner" /></div>
      ) : projects.length === 0 ? (
        <div style={{ color: '#6B7280', fontSize: 14 }}>Belum ada proyek. Buat yang pertama di atas.</div>
      ) : (
        projects.map(p => (
          <div key={p.id} onClick={() => setSelected(p.id)}
            style={{ padding: 16, background: '#F3F4F6', borderRadius: 12,
              marginBottom: 10, cursor: 'pointer', border: '1px solid #E5E7EB',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{p.title || 'Proyek Kompilasi'}</div>
              <div style={{ fontSize: 11, color: '#6B7280', marginTop: 3 }}>
                {p.duration_sec ? `${Math.floor(p.duration_sec/60)} menit` : '—'} · {new Date(p.created_at).toLocaleDateString('id-ID')}
              </div>
            </div>
            <span style={{ fontSize: 11, fontWeight: 600, color: STATUS_COLOR[p.status] || '#6B7280',
              padding: '4px 10px', borderRadius: 999, background: '#F3F4F6' }}>
              {STATUS_LABEL[p.status] || p.status}
            </span>
            {p.persetujuan && (
              <span style={{ fontSize: 11, fontWeight: 600, padding: '4px 10px', borderRadius: 999, marginLeft: 6,
                color: p.persetujuan === 'ditolak' ? '#DC2626' : '#B45309', background: p.persetujuan === 'ditolak' ? 'rgba(239,68,68,0.12)' : 'rgba(217,119,6,0.12)' }}>
                {p.persetujuan === 'ditolak' ? 'Ditolak' : 'Menunggu persetujuan'}
              </span>
            )}
          </div>
        ))
      )}
    </div>
  );
}

// Thumbnail dari DNA (DNA Channel fase 2, 2026-10-07): render lokal di server, gratis.
// Kali pertama dikirim tanpa teks → server mengisi teks bawaan dari gaya channel acuan,
// lalu teks itu ditampilkan di input supaya bisa diedit dan dibuat ulang.
function DnaThumbPanel({ projectId, defaultDnaId, onDone }) {
  const [dnaList, setDnaList] = useState([]);
  const [dnaId, setDnaId] = useState(defaultDnaId || '');
  const [line1, setLine1] = useState('');
  const [line2, setLine2] = useState('');
  const [badge, setBadge] = useState('');
  const [layout, setLayout] = useState('');
  const [edited, setEdited] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [suggest, setSuggest] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/dna`, hdr())
      .then(r => {
        const ready = (r.data || []).filter(d => d.status === 'ready');
        setDnaList(ready);
        if (!defaultDnaId && ready.length === 1) setDnaId(ready[0].id);
      })
      .catch(() => {});
  }, [defaultDnaId]);

  async function render() {
    if (!dnaId) return;
    setBusy(true); setErr('');
    try {
      const body = { dna_id: dnaId };
      if (edited) Object.assign(body, { title_lines: [line1, line2], badge, layout: layout || undefined });
      const r = await axios.post(`${API}/api/ugc/projects/${projectId}/dna-thumbnail`, body, hdr());
      const u = r.data.used;
      setLine1(u.title_lines[0] || ''); setLine2(u.title_lines[1] || ''); setBadge(u.badge || ''); setLayout(u.layout);
      setSuggest(r.data.suggestions?.badges || []);
      setEdited(true);
      onDone();
    } catch (e) {
      setErr(e.response?.data?.error || 'Gagal membuat thumbnail');
    }
    setBusy(false);
  }

  if (!dnaList.length) {
    return <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 10 }}>Punya channel acuan di menu DNA Channel? Thumbnail bisa dibuat mengikuti gayanya, gratis.</div>;
  }
  const field = { padding: '7px 10px', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', width: '100%' };
  return (
    <div style={{ background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: 10, padding: 12, marginBottom: 12 }}>
      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Template dari DNA <span style={{ fontWeight: 400, color: '#059669' }}>· gratis</span></div>
      <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 10 }}>Tracklist diambil otomatis dari lagu proyek, latar dari background video.</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 8, marginBottom: 8 }}>
        <select id="dna-thumb-dna" aria-label="DNA acuan" value={dnaId} onChange={e => { setDnaId(e.target.value); setEdited(false); }} style={field}>
          <option value="">Pilih DNA acuan</option>
          {dnaList.map(d => <option key={d.id} value={d.id}>{d.channel_name || d.channel_url}</option>)}
        </select>
        {edited && (
          <select id="dna-thumb-layout" aria-label="Tata letak" value={layout} onChange={e => setLayout(e.target.value)} style={field}>
            <option value="tracklist">Tata letak: tracklist</option>
            <option value="bigtitle">Tata letak: judul besar</option>
          </select>
        )}
      </div>
      {edited && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 8, marginBottom: 8 }}>
          <input id="dna-thumb-l1" aria-label="Judul baris 1" value={line1} maxLength={40} onChange={e => setLine1(e.target.value)} placeholder="Judul baris 1" style={field} />
          <input id="dna-thumb-l2" aria-label="Judul baris 2" value={line2} maxLength={40} onChange={e => setLine2(e.target.value)} placeholder="Judul baris 2 (opsional)" style={field} />
          <input id="dna-thumb-badge" aria-label="Teks stiker" value={badge} maxLength={24} onChange={e => setBadge(e.target.value)} placeholder="Teks stiker (opsional)" style={field} />
        </div>
      )}
      {edited && suggest.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8, alignItems: 'center' }}>
          <span style={{ fontSize: 11, color: '#6B7280' }}>Stiker yang sering dipakai:</span>
          {suggest.map(s => (
            <button key={s} type="button" onClick={() => setBadge(s)}
              style={{ fontSize: 11, padding: '2px 8px', borderRadius: 6, border: '1px solid #E5E7EB', background: '#F9FAFB', cursor: 'pointer' }}>{s}</button>
          ))}
        </div>
      )}
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <button onClick={render} disabled={busy || !dnaId} className="btn btn-gold" style={{ fontSize: 12, opacity: (busy || !dnaId) ? 0.6 : 1 }}>
          {busy ? 'Membuat...' : edited ? 'Buat ulang dengan teks ini' : 'Buat thumbnail dari DNA'}
        </button>
        {err && <span style={{ fontSize: 12, color: '#DC2626' }}>{err}</span>}
      </div>
    </div>
  );
}

// Judul lagu bisa diedit (2026-10-08): judul hasil unduhan YouTube panjang dan terpotong di
// tracklist/Now Playing. ✎ = edit satu lagu; "Rapikan judul" = usulan otomatis yang bisa dipilih.
function SongTitleRow({ song: s, onSaved, onRemove }) {
  const [edit, setEdit] = useState(false);
  const [title, setTitle] = useState(s.title || '');
  const [artist, setArtist] = useState(s.artist || '');
  const [err, setErr] = useState('');
  const save = async () => {
    setErr('');
    try { await axios.put(`${API}/api/ugc/songs/${s.id}`, { title, artist }, hdr()); setEdit(false); onSaved(); }
    catch (e) { setErr(e.response?.data?.error || 'Gagal menyimpan'); }
  };
  const box = { padding: '9px 12px', background: '#F3F4F6', borderRadius: 8, marginBottom: 6 };
  if (edit) return (
    <div style={box}>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
        <span style={{ fontSize: 12, color: '#6B7280' }}>{s.position}.</span>
        <input value={title} autoFocus maxLength={120} onChange={e => setTitle(e.target.value)} placeholder="Judul lagu"
          onKeyDown={e => { if (e.key === 'Enter') save(); if (e.key === 'Escape') setEdit(false); }} style={{ fontSize: 12, flex: '2 1 200px', padding: '6px 8px' }} />
        <input value={artist} maxLength={120} onChange={e => setArtist(e.target.value)} placeholder="Penyanyi (opsional)"
          onKeyDown={e => { if (e.key === 'Enter') save(); if (e.key === 'Escape') setEdit(false); }} style={{ fontSize: 12, flex: '1 1 140px', padding: '6px 8px' }} />
        <button className="btn btn-gold" style={{ fontSize: 11, padding: '5px 10px' }} onClick={save}>Simpan</button>
        <button className="btn btn-outline" style={{ fontSize: 11, padding: '5px 10px' }} onClick={() => { setEdit(false); setTitle(s.title || ''); setArtist(s.artist || ''); }}>Batal</button>
      </div>
      <div style={{ fontSize: 11, color: '#6B7280', marginTop: 4 }}>{title.length}/120 · judul ini yang tampil di daftar lagu video, Now Playing, dan tracklist deskripsi.</div>
      {err && <div style={{ fontSize: 11, color: '#DC2626', marginTop: 4 }}>{err}</div>}
    </div>
  );
  return (
    <div style={{ ...box, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
      <div style={{ fontSize: 12, minWidth: 0 }}>
        {s.position}. {s.title || s.source_url || 'Untitled'}
        {s.artist ? ` — ${s.artist}` : ''}
        <SongPrepBadge song={s} />
      </div>
      <div style={{ display: 'flex', gap: 12, flexShrink: 0 }}>
        <span onClick={() => setEdit(true)} title="Edit judul lagu" style={{ fontSize: 11, color: '#2563EB', cursor: 'pointer' }}>✎ Edit</span>
        <span onClick={onRemove} style={{ fontSize: 11, color: '#DC2626', cursor: 'pointer' }}>Hapus</span>
      </div>
    </div>
  );
}

function TidyTitlesPanel({ projectId, onDone }) {
  const [items, setItems] = useState(null);
  const [pick, setPick] = useState({});
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState('');
  const open = async () => {
    setNote('');
    try {
      const r = await axios.get(`${API}/api/ugc/projects/${projectId}/songs/tidy`, hdr());
      setItems(r.data.items); setPick(Object.fromEntries(r.data.items.map(x => [x.id, true])));
      if (!r.data.items.length) setNote('Semua judul sudah rapi.');
    } catch (e) { setNote('Gagal mengambil usulan'); }
  };
  const apply = async () => {
    setBusy(true);
    try {
      const chosen = items.filter(x => pick[x.id]).map(x => ({ id: x.id, title: x.suggested }));
      const r = await axios.put(`${API}/api/ugc/projects/${projectId}/songs/titles`, { items: chosen }, hdr());
      setItems(null); setNote(`${r.data.updated} judul dirapikan.`); onDone();
    } catch (e) { setNote(e.response?.data?.error || 'Gagal menyimpan'); }
    setBusy(false);
  };
  return (
    <div style={{ marginBottom: 8 }}>
      {!items ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <button className="btn btn-outline" style={{ fontSize: 12 }} onClick={open}>✨ Rapikan judul lagu</button>
          <span style={{ fontSize: 11, color: '#6B7280' }}>{note || 'Buang buntut seperti "| OFFICIAL LIVE MUSIC VIDEO" atau "(Official MV)" supaya judul tidak terpotong di video.'}</span>
        </div>
      ) : (
        <div style={{ background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: 8, padding: 10 }}>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Usulan judul rapi — centang yang mau dipakai</div>
          {items.map(x => (
            <label key={x.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, padding: '5px 0', borderTop: '1px solid #F3F4F6', cursor: 'pointer' }}>
              <input type="checkbox" checked={!!pick[x.id]} onChange={() => setPick(p => ({ ...p, [x.id]: !p[x.id] }))} style={{ width: 15, height: 15, margin: '2px 0 0', flex: '0 0 auto' }} />
              <span style={{ minWidth: 0 }}>
                <span style={{ color: '#9CA3AF', textDecoration: 'line-through', overflowWrap: 'anywhere' }}>{x.position}. {x.title}</span><br />
                <span style={{ color: '#111827', fontWeight: 600 }}>→ {x.suggested}</span>
              </span>
            </label>
          ))}
          <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
            <button className="btn btn-gold" style={{ fontSize: 12 }} disabled={busy || !items.some(x => pick[x.id])} onClick={apply}>{busy ? 'Menyimpan...' : `Terapkan ${items.filter(x => pick[x.id]).length} judul`}</button>
            <button className="btn btn-outline" style={{ fontSize: 12 }} onClick={() => setItems(null)}>Batal</button>
          </div>
        </div>
      )}
    </div>
  );
}

// SEO & tag YouTube (2026-10-08): judul, deskripsi, dan tag bisa diubah sebelum upload. Tag punya
// sumber (AI / kamu / DNA: nama channel); "Tambah dari DNA" mengambil kata kunci channel DNA dan
// MENAMBAHKAN (tidak menghapus tag yang sudah ada). Batas YouTube 500 karakter (tag berspasi +2).
const TAG_SRC = { ai: { label: 'AI', bg: '#F5F3FF', color: '#6D28D9' }, kamu: { label: 'kamu', bg: '#EFF6FF', color: '#1D4ED8' }, trend: { label: 'Trending', bg: '#FFF7ED', color: '#C2410C' } };
const tagKey = t => String(t || '').replace(/^#/, '').replace(/\s+/g, ' ').trim().toLowerCase();
const tagChars = list => list.reduce((n, t) => n + t.tag.length + (t.tag.includes(' ') ? 2 : 0), 0) + Math.max(0, list.length - 1);

function SeoTagPanel({ projectId, data, full, onSaved }) {
  const [title, setTitle] = useState(data.title || '');
  const [desc, setDesc] = useState(data.description || '');
  const [tags, setTags] = useState(Array.isArray(data.tags) ? data.tags : []);
  const [input, setInput] = useState('');
  const [dirty, setDirty] = useState(false);
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState('');
  const [dnaList, setDnaList] = useState([]);
  const [dnaId, setDnaId] = useState(data.dna_id || '');
  const [dnaKw, setDnaKw] = useState(null);
  // Bahasa (2026-10-22): bahasa utama + terjemahan judul & deskripsi SEPASANG per bahasa.
  const [langs, setLangs] = useState([]);
  const [seoLang, setSeoLang] = useState(data.seo_lang || 'id');
  const [savedLang, setSavedLang] = useState(data.seo_lang || 'id');
  const [locs, setLocs] = useState(data.localizations || {});
  const [pick, setPick] = useState([]);
  const [openLoc, setOpenLoc] = useState('');
  const [tBusy, setTBusy] = useState(false);

  useEffect(() => { setTitle(data.title || ''); setDesc(data.description || ''); setTags(Array.isArray(data.tags) ? data.tags : []); setDirty(false);
    setSeoLang(data.seo_lang || 'id'); setSavedLang(data.seo_lang || 'id'); setLocs(data.localizations || {}); setPick([]); }, [data.id, data.status]); // eslint-disable-line
  useEffect(() => { axios.get(`${API}/api/ugc/languages`, hdr()).then(r => setLangs(r.data.languages || [])).catch(() => {}); }, []);
  const langLabel = c => (langs.find(l => l.code === c) || {}).label || c;
  const translate = async (from, targets) => {
    setTBusy(true); setNote('');
    try {
      const r = await axios.post(`${API}/api/ugc/projects/${projectId}/translate`, { title, description: desc, from, targets }, hdr());
      const failed = Object.keys(r.data.errors || {});
      if (failed.length) setNote(`Gagal menerjemahkan: ${failed.map(langLabel).join(', ')}. Coba lagi.`);
      return r.data.result || {};
    } catch (e) { setNote(e.response?.data?.error || 'Gagal menerjemahkan'); return {}; }
    finally { setTBusy(false); }
  };
  const translateTargets = async () => {
    const res = await translate(seoLang, pick);
    if (Object.keys(res).length) { setLocs(prev => ({ ...prev, ...res })); setPick([]); setOpenLoc(Object.keys(res)[0]); setDirty(true); }
  };
  const translateMain = async () => {
    const res = await translate(savedLang, [seoLang]);
    if (res[seoLang]) { setTitle(res[seoLang].title); setDesc(res[seoLang].description); setSavedLang(seoLang); setDirty(true); setNote(`Judul & deskripsi utama diterjemahkan ke ${langLabel(seoLang)}. Cek lalu simpan.`); }
  };
  useEffect(() => {
    axios.get(`${API}/api/dna`, hdr()).then(r => {
      const ready = (r.data || []).filter(d => d.status === 'ready');
      setDnaList(ready);
      if (!dnaId && ready.length === 1) setDnaId(ready[0].id);
    }).catch(() => {});
  }, []); // eslint-disable-line

  const add = (items, src) => {
    setTags(prev => {
      const seen = new Set(prev.map(t => tagKey(t.tag)));
      const out = [...prev];
      items.forEach(raw => {
        const tag = String(raw || '').replace(/^#/, '').replace(/[<>",]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 60);
        if (tag && !seen.has(tag.toLowerCase())) { seen.add(tag.toLowerCase()); out.push({ tag, src }); }
      });
      return out;
    });
    setDirty(true);
  };
  const addInput = () => { if (input.trim()) { add(input.split(','), 'kamu'); setInput(''); } };
  const loadDna = async () => {
    if (!dnaId) return;
    try { const r = await axios.get(`${API}/api/ugc/projects/${projectId}/dna-tags?dna_id=${encodeURIComponent(dnaId)}`, hdr()); setDnaKw(r.data); }
    catch (e) { setNote('Gagal mengambil kata kunci DNA'); }
  };
  const save = async () => {
    setBusy(true); setNote('');
    try {
      const body = full ? { title, description: desc, tags, seo_lang: seoLang, localizations: locs } : { tags, seo_lang: seoLang };
      const r = await axios.put(`${API}/api/ugc/projects/${projectId}/seo`, body, hdr());
      setTags(r.data.tags); setLocs(r.data.localizations || {}); setSavedLang(r.data.seo_lang || 'id'); setDirty(false); setNote('Tersimpan. Dipakai saat video diupload ke YouTube.'); onSaved && onSaved();
    } catch (e) { setNote(e.response?.data?.error || 'Gagal menyimpan'); }
    setBusy(false);
  };

  const chars = tagChars(tags);
  const have = new Set(tags.map(t => tagKey(t.tag)));
  const srcStyle = src => (src && src.startsWith('dna:')) ? { label: `DNA: ${src.slice(4)}`, bg: '#ECFDF5', color: '#047857' } : (TAG_SRC[src] || TAG_SRC.kamu);
  const field = { fontSize: 13 };
  return (
    <div style={{ background: '#F3F4F6', padding: 14, borderRadius: 10, marginBottom: 20 }}>
      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>SEO & Tag YouTube</div>
      <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 10 }}>
        {full ? 'Judul, deskripsi, dan tag ini dipakai saat video diupload. Bisa diubah sampai video diupload.'
              : 'Judul & deskripsi dibuat AI setelah video jadi. Tag yang kamu tambahkan sekarang tetap dipakai dan digabung dengan tag dari AI.'}
      </div>
      {full && (
        <>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Judul <span style={{ fontWeight: 400, color: title.length > 100 ? '#DC2626' : '#6B7280' }}>{title.length}/100</span></div>
          <input value={title} maxLength={100} onChange={e => { setTitle(e.target.value); setDirty(true); }} style={{ ...field, marginBottom: 10 }} />
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Deskripsi <span style={{ fontWeight: 400, color: '#6B7280' }}>(tracklist berisi timestamp; biarkan supaya bab video tetap muncul)</span></div>
          <textarea value={desc} rows={8} onChange={e => { setDesc(e.target.value); setDirty(true); }} style={{ ...field, width: '100%', marginBottom: 10, fontFamily: 'inherit', boxSizing: 'border-box' }} />
        </>
      )}
      <div style={{ background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: 8, padding: 10, marginBottom: 12 }}>
        <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Bahasa judul & deskripsi</div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, flexWrap: 'wrap' }}>
          Bahasa utama
          <select value={seoLang} onChange={e => { const v = e.target.value; setSeoLang(v); setLocs(prev => { const n = { ...prev }; delete n[v]; return n; }); setDirty(true); }} style={{ fontSize: 12, width: 'auto', padding: '5px 8px' }}>
            {(langs.length ? langs : [{ code: 'id', label: 'Indonesia' }]).map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
          </select>
        </label>
        <div style={{ fontSize: 11.5, color: '#6B7280', marginTop: 6, lineHeight: 1.5 }}>
          {full ? 'Dilihat penonton yang bahasa YouTube-nya tidak ada di daftar terjemahan di bawah.'
                : 'AI menulis judul, deskripsi & tag dalam bahasa ini setelah video selesai dirender. Terjemahan ke bahasa lain bisa ditambah setelah itu.'}
        </div>
        {full && seoLang !== savedLang && (
          <div style={{ fontSize: 12, marginTop: 8, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ color: '#B45309' }}>Judul & deskripsi utama masih bahasa {langLabel(savedLang)}.</span>
            <button className="btn btn-outline" style={{ fontSize: 12 }} disabled={tBusy} onClick={translateMain}>{tBusy ? 'Menerjemahkan…' : `Terjemahkan ke ${langLabel(seoLang)}`}</button>
          </div>
        )}
        {full && (
          <>
            <div style={{ fontSize: 12, fontWeight: 600, margin: '12px 0 4px' }}>Terjemahan untuk penonton bahasa lain <span style={{ fontWeight: 400, color: '#6B7280' }}>({Object.keys(locs).length})</span></div>
            <div style={{ fontSize: 11.5, color: '#6B7280', marginBottom: 6, lineHeight: 1.5 }}>
              Tiap bahasa berisi judul <b>dan</b> deskripsi. YouTube menampilkan versi yang cocok dengan bahasa penonton. Timestamp daftar lagu & link tidak diterjemahkan, jadi bab video tetap jalan.
            </div>
            {Object.keys(locs).map(c => (
              <div key={c} style={{ border: '1px solid #E5E7EB', borderRadius: 8, marginBottom: 6, background: '#F9FAFB' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', cursor: 'pointer' }} onClick={() => setOpenLoc(openLoc === c ? '' : c)}>
                  <b style={{ fontSize: 12, minWidth: 70 }}>{langLabel(c)}</b>
                  <span style={{ flex: 1, fontSize: 12, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{locs[c].title}</span>
                  <span onClick={e => { e.stopPropagation(); setLocs(prev => { const n = { ...prev }; delete n[c]; return n; }); setDirty(true); }} title="Hapus terjemahan ini" style={{ color: '#9CA3AF', fontWeight: 700, padding: '0 4px' }}>×</span>
                </div>
                {openLoc === c && (
                  <div style={{ padding: '0 10px 10px' }}>
                    <input value={locs[c].title} maxLength={100} onChange={e => { const v = e.target.value; setLocs(prev => ({ ...prev, [c]: { ...prev[c], title: v } })); setDirty(true); }} style={{ ...field, marginBottom: 6 }} />
                    <textarea value={locs[c].description} rows={6} onChange={e => { const v = e.target.value; setLocs(prev => ({ ...prev, [c]: { ...prev[c], description: v } })); setDirty(true); }} style={{ ...field, width: '100%', fontFamily: 'inherit', boxSizing: 'border-box' }} />
                  </div>
                )}
              </div>
            ))}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, margin: '6px 0' }}>
              {langs.filter(l => l.code !== seoLang && !locs[l.code]).map(l => { const on = pick.includes(l.code); return (
                <span key={l.code} onClick={() => setPick(p => on ? p.filter(x => x !== l.code) : (p.length + Object.keys(locs).length >= 10 ? p : [...p, l.code]))}
                  style={{ fontSize: 12, borderRadius: 999, padding: '3px 10px', cursor: 'pointer', border: `1px solid ${on ? '#2563EB' : '#E5E7EB'}`, color: on ? '#1D4ED8' : '#374151', background: on ? '#EFF6FF' : '#FFFFFF' }}>
                  {on ? '✓ ' : '+ '}{l.label}
                </span>
              ); })}
            </div>
            <button className="btn btn-outline" style={{ fontSize: 12 }} disabled={!pick.length || tBusy || seoLang !== savedLang} onClick={translateTargets}>
              {tBusy ? 'Menerjemahkan…' : pick.length ? `Terjemahkan ke ${pick.length} bahasa` : 'Pilih bahasa di atas'}
            </button>
            {seoLang !== savedLang && <span style={{ fontSize: 11.5, color: '#6B7280', marginLeft: 8 }}>Samakan dulu bahasa teks utama.</span>}
            <div style={{ fontSize: 11, color: '#6B7280', marginTop: 6 }}>Kalau judul/deskripsi utama diubah lagi, hapus & terjemahkan ulang supaya isinya sama. Maks 10 bahasa.</div>
          </>
        )}
      </div>
      <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>
        Tag <span style={{ fontWeight: 400, color: chars > 500 ? '#DC2626' : '#6B7280' }}>{tags.length} tag · {chars}/500 karakter{chars > 500 ? ' — kelebihan dipangkas otomatis dari tag paling bawah' : ''}</span>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
        {tags.length === 0 && <span style={{ fontSize: 12, color: '#6B7280' }}>Belum ada tag.</span>}
        {tags.map((t, i) => { const st = srcStyle(t.src); return (
          <span key={t.tag + i} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: 999, padding: '3px 6px 3px 10px', fontSize: 12, maxWidth: '100%' }}>
            <span style={{ overflowWrap: 'anywhere' }}>{t.tag}</span>
            <span style={{ fontSize: 10, fontWeight: 700, background: st.bg, color: st.color, borderRadius: 999, padding: '1px 6px', whiteSpace: 'nowrap' }}>{st.label}</span>
            <span onClick={() => { setTags(prev => prev.filter((_, j) => j !== i)); setDirty(true); }} title="Hapus tag ini" style={{ cursor: 'pointer', color: '#9CA3AF', fontWeight: 700, padding: '0 2px' }}>×</span>
          </span>
        ); })}
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
        <input value={input} onChange={e => setInput(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addInput(); } }}
          placeholder="Tambah tag sendiri (pisahkan dengan koma, Enter)" style={{ ...field, flex: '1 1 200px' }} />
        <button className="btn btn-outline" style={{ fontSize: 12 }} onClick={addInput}>+ Tag</button>
      </div>
      <div style={{ background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: 8, padding: 10, marginBottom: 10 }}>
        <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Tambah dari channel DNA <span style={{ fontWeight: 400, color: '#6B7280' }}>— tag yang sudah ada tidak dihapus</span></div>
        {dnaList.length === 0 ? (
          <div style={{ fontSize: 12, color: '#6B7280' }}>Belum ada DNA. Tambahkan channel acuan di menu DNA Channel.</div>
        ) : (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', minWidth: 0 }}>
            <select value={dnaId} onChange={e => { setDnaId(e.target.value); setDnaKw(null); }} style={{ ...field, width: 'auto', maxWidth: '100%', minWidth: 0, padding: '6px 10px' }}>
              <option value="">Pilih channel DNA</option>
              {dnaList.map(d => <option key={d.id} value={d.id}>{d.channel_name || d.channel_url}</option>)}
            </select>
            <button className="btn btn-outline" style={{ fontSize: 12 }} disabled={!dnaId} onClick={loadDna}>Lihat kata kunci</button>
          </div>
        )}
        {dnaKw && (
          dnaKw.keywords.length === 0 ? <div style={{ fontSize: 12, color: '#6B7280', marginTop: 8 }}>Channel ini tidak punya kata kunci yang bisa dipakai.</div> : (
            <div style={{ marginTop: 8 }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {dnaKw.keywords.map(k => { const on = have.has(tagKey(k)); return (
                  <span key={k} onClick={() => !on && add([k], `dna:${dnaKw.dna.name}`)}
                    style={{ fontSize: 12, borderRadius: 999, padding: '3px 10px', cursor: on ? 'default' : 'pointer', border: `1px solid ${on ? '#E5E7EB' : '#10B981'}`, color: on ? '#9CA3AF' : '#047857', background: on ? '#F9FAFB' : '#ECFDF5' }}>
                    {on ? '✓ ' : '+ '}{k}
                  </span>
                ); })}
              </div>
              <span onClick={() => add(dnaKw.keywords, `dna:${dnaKw.dna.name}`)} style={{ display: 'inline-block', marginTop: 8, fontSize: 12, color: '#2563EB', cursor: 'pointer' }}>Tambah semua</span>
              {dnaKw.removedBrand > 0 && <span style={{ fontSize: 11, color: '#6B7280', marginLeft: 10 }}>(nama/merek channel acuan otomatis disaring)</span>}
            </div>
          )
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <button className="btn btn-gold" style={{ fontSize: 12 }} disabled={busy || !dirty} onClick={save}>{busy ? 'Menyimpan...' : 'Simpan SEO & tag'}</button>
        {dirty && <span style={{ fontSize: 12, color: '#D97706' }}>Belum disimpan</span>}
        {note && <span style={{ fontSize: 12, color: '#111827' }}>{note}</span>}
      </div>
    </div>
  );
}

// Panel "Lagu yang pernah kamu pakai" (2026-10-08): riwayat lagu akun ini dikelompokkan per artis
// (nama artis ditebak dari judul, bisa dikoreksi ✎), dengan pencarian & centang banyak sekaligus.
// Lagu yang sudah ada di gudang lagu langsung siap tanpa unduh.
function SongHistoryPanel({ projectId, songCount, onAdded }) {
  const [songs, setSongs] = useState(null);
  const [q, setQ] = useState('');
  const [sel, setSel] = useState(() => new Set());
  const [open, setOpen] = useState(() => new Set());
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState('');
  const [edit, setEdit] = useState(null); // { key, value }

  const load = async () => {
    try { const r = await axios.get(`${API}/api/ugc/song-history?project=${projectId}`, hdr()); setSongs(r.data.songs); }
    catch (e) { setSongs([]); }
  };
  useEffect(() => { load(); }, [projectId]); // eslint-disable-line

  if (!songs) return <div style={{ fontSize: 12, color: '#6B7280', padding: 10 }}>Memuat riwayat lagu...</div>;
  if (!songs.length) return <div style={{ fontSize: 12, color: '#6B7280', padding: 10 }}>Belum ada riwayat lagu. Lagu dari proyek-proyekmu akan muncul di sini.</div>;

  const norm = t => String(t || '').toLowerCase();
  const nq = norm(q).trim(), nq2 = nq.replace(/\s+/g, '');
  const match = x => !nq || norm(x.title).includes(nq) || x.artists.some(a => norm(a.name).includes(nq) || a.key.includes(nq2));
  const groups = new Map();
  songs.filter(match).forEach(x => {
    const list = x.artists.length ? x.artists : [{ key: '_', name: 'Belum ada nama artis' }];
    list.forEach(a => { if (!groups.has(a.key)) groups.set(a.key, { key: a.key, name: a.name, songs: [] }); groups.get(a.key).songs.push(x); });
  });
  const sorted = [...groups.values()].sort((a, b) => (a.key === '_') - (b.key === '_') || b.songs.length - a.songs.length || a.name.localeCompare(b.name));
  const room = Math.max(0, 30 - songCount);
  const mmss = v => (v ? `${Math.floor(v / 60)}:${String(Math.round(v % 60)).padStart(2, '0')}` : '');
  const toggle = keys => setSel(prev => {
    const n = new Set(prev);
    const all = keys.every(k => n.has(k));
    keys.forEach(k => (all ? n.delete(k) : n.add(k)));
    return n;
  });
  const isOpen = k => !!nq || open.has(k);
  const box = { width: 16, height: 16, padding: 0, margin: 0, flex: '0 0 auto', cursor: 'pointer' };

  const add = async () => {
    setBusy(true); setNote('');
    try {
      const r = await axios.post(`${API}/api/ugc/projects/${projectId}/songs/from-history`, { keys: [...sel] }, hdr());
      const d = r.data;
      const parts = [`${d.added} lagu ditambahkan (${d.ready} langsung siap${d.added - d.ready ? `, ${d.added - d.ready} diunduh di belakang layar` : ''}).`];
      if (d.exist) parts.push(`${d.exist} sudah ada di proyek.`);
      if (d.full) parts.push(`${d.full} tidak muat (maks 30 lagu).`);
      setNote(parts.join(' '));
      setSel(new Set());
      await load();
      onAdded();
    } catch (e) { setNote(e.response?.data?.error || 'Gagal menambahkan lagu'); }
    setBusy(false);
  };
  const saveArtist = async () => {
    try { await axios.put(`${API}/api/ugc/song-history/artist`, { key: edit.key, artist: edit.value }, hdr()); setEdit(null); load(); }
    catch (e) { setNote('Gagal menyimpan nama artis'); }
  };

  return (
    <div style={{ border: '1px solid #E5E7EB', borderRadius: 10, background: '#FFFFFF', marginBottom: 10 }}>
      <div style={{ padding: 10, borderBottom: '1px solid #E5E7EB' }}>
        <input placeholder="Cari judul lagu atau nama artis..." value={q} onChange={e => setQ(e.target.value)} style={{ fontSize: 12 }} autoFocus />
        <div style={{ fontSize: 11, color: '#6B7280', marginTop: 6 }}>
          {songs.length} lagu dari proyek-proyekmu. Nama artis ditebak dari judul; klik ✎ untuk membetulkan.
        </div>
      </div>
      <div style={{ maxHeight: 380, overflowY: 'auto' }}>
        {sorted.length === 0 && <div style={{ fontSize: 12, color: '#6B7280', padding: 12 }}>Tidak ada lagu yang cocok dengan "{q}".</div>}
        {sorted.map(g => {
          const keys = g.songs.filter(x => !x.inProject).map(x => x.key);
          const on = keys.filter(k => sel.has(k)).length;
          return (
            <div key={g.key} style={{ borderBottom: '1px solid #F3F4F6' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', background: '#F9FAFB' }}>
                <input type="checkbox" style={box} disabled={!keys.length} checked={keys.length > 0 && on === keys.length}
                  ref={el => { if (el) el.indeterminate = on > 0 && on < keys.length; }} onChange={() => toggle(keys)} title="Pilih semua lagu artis ini" />
                <div onClick={() => setOpen(prev => { const n = new Set(prev); n.has(g.key) ? n.delete(g.key) : n.add(g.key); return n; })}
                  style={{ flex: 1, cursor: 'pointer', fontSize: 13, fontWeight: 600, display: 'flex', justifyContent: 'space-between' }}>
                  <span>{g.name} <span style={{ fontWeight: 400, color: '#6B7280' }}>· {g.songs.length} lagu{on ? ` · ${on} dipilih` : ''}</span></span>
                  <span style={{ color: '#9CA3AF' }}>{isOpen(g.key) ? '▾' : '▸'}</span>
                </div>
              </div>
              {isOpen(g.key) && g.songs.map(x => (
                <div key={g.key + x.key} style={{ padding: '6px 10px 6px 34px', fontSize: 12, opacity: x.inProject ? 0.55 : 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <input type="checkbox" style={box} disabled={x.inProject} checked={x.inProject || sel.has(x.key)} onChange={() => toggle([x.key])} />
                    <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={x.title}>{x.title}</span>
                    <span style={{ color: '#6B7280', whiteSpace: 'nowrap' }}>{mmss(x.duration)}</span>
                    <span style={{ fontSize: 11, whiteSpace: 'nowrap', color: x.inProject ? '#6B7280' : x.ready ? '#059669' : '#D97706' }}>
                      {x.inProject ? 'sudah di proyek' : x.ready ? '✓ siap' : 'perlu unduh'}
                    </span>
                    <span onClick={() => setEdit({ key: x.key, value: x.artists.map(a => a.name).join(', ') })} title="Betulkan nama artis"
                      style={{ cursor: 'pointer', color: '#6B7280' }}>✎</span>
                  </div>
                  {edit && edit.key === x.key && (
                    <div style={{ display: 'flex', gap: 6, marginTop: 6, flexWrap: 'wrap' }}>
                      <input value={edit.value} onChange={e => setEdit({ ...edit, value: e.target.value })} placeholder="Nama artis (pisahkan koma bila lebih dari satu)"
                        style={{ flex: '1 1 200px', fontSize: 12, padding: '5px 8px' }} onKeyDown={e => { if (e.key === 'Enter') saveArtist(); }} />
                      <button className="btn btn-gold" style={{ fontSize: 11, padding: '4px 10px' }} onClick={saveArtist}>Simpan</button>
                      <button className="btn btn-outline" style={{ fontSize: 11, padding: '4px 10px' }} onClick={() => setEdit(null)}>Batal</button>
                      {!x.guessed && <button className="btn btn-outline" style={{ fontSize: 11, padding: '4px 10px' }} onClick={() => { setEdit({ ...edit, value: '' }); axios.put(`${API}/api/ugc/song-history/artist`, { key: x.key, artist: '' }, hdr()).then(() => { setEdit(null); load(); }); }}>Pakai tebakan otomatis</button>}
                    </div>
                  )}
                </div>
              ))}
            </div>
          );
        })}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: 10, borderTop: '1px solid #E5E7EB', flexWrap: 'wrap' }}>
        <span style={{ flex: 1, fontSize: 12, color: sel.size > room ? '#DC2626' : '#6B7280' }}>
          {sel.size} lagu dipilih · sisa tempat {room} lagu{sel.size > room ? ' (kelebihan tidak ikut ditambahkan)' : ''}
        </span>
        {sel.size > 0 && <span onClick={() => setSel(new Set())} style={{ fontSize: 12, color: '#6B7280', cursor: 'pointer' }}>Kosongkan</span>}
        <button className="btn btn-gold" style={{ fontSize: 12 }} disabled={busy || !sel.size || !room} onClick={add}>{busy ? 'Menambahkan...' : `Tambah ${sel.size || ''} ke proyek`}</button>
        {note && <div style={{ width: '100%', fontSize: 12, color: '#111827' }}>{note}</div>}
      </div>
    </div>
  );
}

// "Buat lagi dengan urutan baru" (2026-10-08): proyek baru dari proyek ini — lagu, tampilan editor
// & latar disalin, urutan lagu diacak (belum pernah dipakai di proyek-proyek turunannya).
function RemakeBar({ projectId, songCount, onOpen }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const go = async () => {
    setBusy(true); setErr('');
    try {
      const r = await axios.post(`${API}/api/ugc/projects/${projectId}/remake`, {}, hdr());
      const d = r.data;
      const notes = [`Proyek baru dibuat dengan urutan lagu baru (pembuka: ${d.firstSong || '-'}).`];
      notes.push(d.ready === d.total ? 'Semua lagu sudah siap dari gudang lagu, tidak perlu unduh ulang.' : `${d.ready} dari ${d.total} lagu langsung siap; sisanya diunduh di belakang layar.`);
      if (d.sameOrder) notes.push('Semua kemungkinan urutan sudah pernah dipakai, jadi urutannya sama dengan sebelumnya.');
      if (d.skipped) notes.push(`${d.skipped} lagu upload tidak ikut karena filenya sudah tidak ada.`);
      notes.push('Pilih thumbnail & channel, cek tampilan, lalu proses.');
      setBusy(false);
      onOpen(d.id, notes.join(' '));
      return;
    } catch (e) { setErr(e.response?.data?.error || 'Gagal membuat proyek baru'); }
    setBusy(false);
  };
  return (
    <div style={{ background: '#F5F3FF', border: '1px solid #DDD6FE', padding: 12, borderRadius: 10, marginBottom: 18, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      <div style={{ flex: 1, minWidth: 220, fontSize: 12, color: '#4B5563' }}>
        <b style={{ color: '#111827' }}>Pakai lagu yang sama lagi?</b> Buat proyek baru dengan {songCount} lagu ini, tampilan & latar yang sama, tapi urutan lagu diacak. Lagu yang sudah pernah diunduh langsung siap.
      </div>
      <button onClick={go} disabled={busy} className="btn btn-gold" style={{ fontSize: 12 }}>{busy ? 'Membuat...' : '🔀 Buat lagi dengan urutan baru'}</button>
      {err && <div style={{ width: '100%', fontSize: 12, color: '#DC2626' }}>{err}</div>}
    </div>
  );
}

// Batch N paket sekaligus (2026-10-22, dari WSA Studio Pro): 2-10 proyek dengan urutan lagu unik,
// latar bergilir dari file yang diunggah, channel dibagi rata (tiap channel dapat versi berbeda).
function BatchBar({ projectId, songCount, sourceChannels, onOpen }) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(3);
  const [files, setFiles] = useState([]);
  const [channels, setChannels] = useState([]);
  const [sel, setSel] = useState(() => (sourceChannels || []).map(c => String(c.channel_id)));
  const [processNow, setProcessNow] = useState(true);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [result, setResult] = useState(null);
  useEffect(() => {
    if (!open || channels.length) return;
    axios.get(`${API}/api/youtube/channels`, hdr()).then(r => setChannels((r.data || []).filter(c => c.is_active !== false))).catch(() => {});
  }, [open]); // eslint-disable-line
  const totalMb = files.reduce((s, f) => s + f.size, 0) / 1048576;
  const perPkg = sel.length ? Math.floor(sel.length / count) : 0;
  const go = async () => {
    setErr('');
    if (sel.length && sel.length < count) { setErr(`Channel terpilih (${sel.length}) lebih sedikit dari jumlah paket (${count}). Kurangi paket atau tambah channel.`); return; }
    if (totalMb > 450) { setErr('Total file latar maksimal 450 MB. Kurangi atau perkecil filenya.'); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('count', String(count));
      fd.append('channel_ids', JSON.stringify(sel));
      fd.append('process', processNow ? 'true' : 'false');
      files.forEach(f => fd.append('visuals', f));
      const r = await axios.post(`${API}/api/ugc/projects/${projectId}/batch`, fd, hdr());
      setResult(r.data);
    } catch (e) { setErr(e.response?.data?.error || 'Gagal membuat paket'); }
    setBusy(false);
  };
  const box = { background: '#F5F3FF', border: '1px solid #DDD6FE', padding: 12, borderRadius: 10, marginBottom: 18 };
  if (result) {
    return (
      <div style={box}>
        <div style={{ fontSize: 12.5, fontWeight: 600, color: '#111827', marginBottom: 6 }}>
          ✅ {result.packages.length} paket dibuat{result.processing ? ' dan masuk antrean render (diproses satu per satu)' : ' sebagai draft'}
        </div>
        {result.sameOrder > 0 && <div style={{ fontSize: 11.5, color: '#B45309', marginBottom: 6 }}>{result.sameOrder} paket memakai urutan yang sudah pernah ada karena kemungkinan urutan baru sudah habis.</div>}
        {result.packages.map(p => (
          <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, padding: '6px 0', borderTop: '1px solid #EDE9FE', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 180 }}>
              <b>Paket {p.batch_no}</b> · pembuka: {p.firstSong || '-'}
              <span style={{ color: '#6B7280' }}> · {p.channels} channel{p.visual ? ` · latar ${p.visual}` : ''}</span>
            </div>
            <button className="btn btn-outline" style={{ fontSize: 11.5, padding: '4px 10px' }}
              onClick={() => onOpen(p.id, result.processing ? 'Paket ini sedang menunggu giliran render. Setelah siap, setujui upload seperti biasa.' : 'Paket batch: cek tampilan & thumbnail, lalu proses.')}>Buka</button>
          </div>
        ))}
        <div style={{ fontSize: 11, color: '#6B7280', marginTop: 6 }}>Setelah tiap paket siap, setujui/jadwalkan uploadnya dari halaman paket masing-masing. Thumbnail bisa diatur per paket.</div>
      </div>
    );
  }
  if (!open) {
    return (
      <div style={{ ...box, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 220, fontSize: 12, color: '#4B5563' }}>
          <b style={{ color: '#111827' }}>Butuh banyak versi?</b> Buat 2-10 paket sekaligus dari {songCount} lagu ini: urutan lagu beda tiap paket, latar bisa bergilir, dan channel dibagi supaya tiap channel dapat versi berbeda.
        </div>
        <button onClick={() => setOpen(true)} className="btn btn-gold" style={{ fontSize: 12 }}>📦 Buat banyak paket sekaligus</button>
      </div>
    );
  }
  const toggle = id => setSel(p => p.includes(id) ? p.filter(x => x !== id) : (p.length >= 100 ? p : [...p, id]));
  return (
    <div style={box}>
      <div style={{ fontSize: 13, fontWeight: 600, color: '#111827', marginBottom: 10 }}>📦 Buat banyak paket sekaligus</div>
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, marginBottom: 12, flexWrap: 'wrap' }}>
        Jumlah paket
        <select value={count} onChange={e => setCount(Number(e.target.value))} style={{ padding: '5px 8px', borderRadius: 7, border: '1px solid #D1D5DB' }}>
          {[2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        <span style={{ fontSize: 11.5, color: '#6B7280' }}>Tiap paket dapat urutan lagu yang belum pernah dipakai.</span>
      </label>

      <div style={{ fontSize: 12.5, fontWeight: 600, marginBottom: 4 }}>Latar bergilir (opsional)</div>
      <div style={{ fontSize: 11.5, color: '#6B7280', marginBottom: 6 }}>Pilih beberapa foto/video (JPG, PNG, WEBP, MP4). Paket 1 pakai file 1, paket 2 file 2, dan seterusnya bergiliran. Kosong = semua paket pakai latar proyek ini.</div>
      <input type="file" multiple accept=".jpg,.jpeg,.png,.webp,.mp4" onChange={e => setFiles(Array.from(e.target.files || []).slice(0, 10))} style={{ fontSize: 12, marginBottom: 4, maxWidth: '100%' }} />
      {files.length > 0 && <div style={{ fontSize: 11.5, color: totalMb > 450 ? '#DC2626' : '#4B5563', marginBottom: 12 }}>{files.length} file · {totalMb.toFixed(0)} MB{files.length > count ? ` · hanya ${count} file pertama yang terpakai` : ''}</div>}
      {files.length === 0 && <div style={{ marginBottom: 12 }} />}

      <div style={{ fontSize: 12.5, fontWeight: 600, marginBottom: 4 }}>Channel dibagi ke paket ({sel.length} dipilih{sel.length >= count ? ` · ±${perPkg}${sel.length % count ? '-' + (perPkg + 1) : ''} per paket` : ''})</div>
      <div style={{ fontSize: 11.5, color: '#6B7280', marginBottom: 6 }}>Channel dibagi rata bergiliran, jadi tiap channel menerima versi yang berbeda. Kosong = paket dibuat tanpa channel (atur nanti per paket).</div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
        <button className="btn btn-outline" style={{ fontSize: 11.5, padding: '3px 9px' }} onClick={() => setSel(channels.slice(0, 100).map(c => String(c.id)))}>Pilih semua (≤100)</button>
        <button className="btn btn-outline" style={{ fontSize: 11.5, padding: '3px 9px' }} onClick={() => setSel([])}>Kosongkan</button>
      </div>
      <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #E5E7EB', borderRadius: 8, padding: 6, background: '#fff', marginBottom: 12 }}>
        {channels.length === 0 ? <div style={{ fontSize: 12, color: '#6B7280', padding: 4 }}>Memuat channel...</div> : channels.map(ch => (
          <label key={ch.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, padding: '3px 4px', cursor: 'pointer', minWidth: 0 }}>
            <input type="checkbox" checked={sel.includes(String(ch.id))} onChange={() => toggle(String(ch.id))} style={{ width: 14, height: 14, margin: 0, flexShrink: 0 }} />
            <span style={{ overflowWrap: 'anywhere' }}>{ch.channel_name || 'Channel'}</span>
          </label>
        ))}
      </div>

      <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 12.5, marginBottom: 4, cursor: 'pointer' }}>
        <input type="checkbox" checked={processNow} onChange={e => setProcessNow(e.target.checked)} style={{ width: 15, height: 15, margin: '1px 0 0' }} />
        <span>Langsung proses semua paket<br /><span style={{ fontSize: 11.5, color: '#6B7280' }}>Render berjalan satu per satu. Deklarasi YouTube & batas ukuran mengikuti proyek ini. Upload tetap menunggu kamu setujui per paket.</span></span>
      </label>

      {err && <div style={{ fontSize: 12, color: '#DC2626', margin: '8px 0' }}>{err}</div>}
      <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
        <button className="btn btn-gold" disabled={busy} onClick={go} style={{ fontSize: 12 }}>{busy ? 'Membuat paket...' : `Buat ${count} paket`}</button>
        <button className="btn btn-outline" disabled={busy} onClick={() => { setOpen(false); setErr(''); }} style={{ fontSize: 12 }}>Batal</button>
      </div>
    </div>
  );
}

// Label kesiapan lagu (unduhan awal 2026-10-08, lihat scripts/ugc-prefetch-song.js di API).
function SongPrepBadge({ song: s }) {
  const mmss = v => `${Math.floor(v / 60)}:${String(Math.round(v % 60)).padStart(2, '0')}`;
  let text, color;
  if (s.status === 'ready') { text = `✓ siap${s.duration_sec ? ` · ${mmss(s.duration_sec)}` : ''}`; color = '#059669'; }
  else if (s.status === 'prefetching') { text = '⏳ sedang diunduh...'; color = '#2563EB'; }
  else if (String(s.error_message || '').startsWith('prefetch:')) { text = 'diunduh saat proses video'; color = '#D97706'; }
  else { text = s.source_type === 'youtube_url' ? 'antre unduh' : 'antre disiapkan'; color = '#6B7280'; }
  return <span style={{ marginLeft: 8, fontSize: 11, color, whiteSpace: 'nowrap' }}>{text}</span>;
}

// Potongan Shorts (editor Tahap 3, 2026-10-08): klip vertikal 1080x1920 dari video kompilasi.
function ShortsPanel({ projectId, songs }) {
  const [info, setInfo] = useState(null);
  const [songId, setSongId] = useState('');
  const [startIn, setStartIn] = useState(null);
  const [duration, setDuration] = useState(30);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const pollRef = useRef(null);
  const ready = songs.filter(s => s.start_offset_sec != null);
  const song = ready.find(s => String(s.id) === String(songId)) || ready[0];
  const songDur = song ? Number(song.duration_sec) || duration : duration;
  const maxStart = Math.max(0, Math.floor(songDur - duration));
  const start = startIn == null ? Math.min(maxStart, Math.round(songDur * 0.3)) : Math.min(maxStart, startIn);
  const mmss = v => `${Math.floor(v / 60)}:${String(Math.floor(v % 60)).padStart(2, '0')}`;

  const load = async () => {
    try {
      const r = await axios.get(`${API}/api/ugc/projects/${projectId}/shorts`, hdr());
      setInfo(r.data);
      clearTimeout(pollRef.current);
      if (r.data.items.some(x => x.status === 'processing')) pollRef.current = setTimeout(load, 4000);
    } catch (e) { /* toast global */ }
  };
  useEffect(() => { load(); return () => clearTimeout(pollRef.current); }, [projectId]); // eslint-disable-line

  const create = async () => {
    if (!song) return;
    setBusy(true); setErr('');
    try {
      await axios.post(`${API}/api/ugc/projects/${projectId}/shorts`, { song_id: song.id, start_in_song: start, duration }, hdr());
      await load();
    } catch (e) { setErr(e.response?.data?.error || 'Gagal membuat Shorts'); }
    setBusy(false);
  };
  const remove = async (sid) => {
    if (!window.confirm('Hapus Shorts ini?')) return;
    try { await axios.delete(`${API}/api/ugc/shorts/${sid}`, hdr()); load(); } catch (e) { setErr('Gagal menghapus'); }
  };
  const fileUrl = (sid, dl) => `${API}/api/ugc/shorts-file/${sid}?token=${encodeURIComponent(localStorage.getItem('sm_token'))}${dl ? '&download=1' : ''}`;

  if (!info || !ready.length) return null;
  return (
    <div style={{ background: '#F3F4F6', padding: 14, borderRadius: 10, marginBottom: 20 }}>
      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Potongan Shorts</div>
      <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 10 }}>
        Klip vertikal dari video ini: latar blur, video di tengah, judul lagu di atas. Unduh lalu unggah sebagai Shorts untuk menarik penonton ke video lengkapnya. Maks {info.max} per proyek.
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: 8 }}>
        <select value={song ? song.id : ''} onChange={e => { setSongId(e.target.value); setStartIn(null); }} style={{ padding: '7px 10px', borderRadius: 8, fontSize: 13, width: 'auto', maxWidth: '100%' }}>
          {ready.map(s => <option key={s.id} value={s.id}>{String(s.position).padStart(2, '0')}. {s.title}</option>)}
        </select>
        {info.durations.map(d => (
          <button key={d} onClick={() => setDuration(d)}
            style={{ padding: '6px 10px', borderRadius: 8, fontSize: 12, cursor: 'pointer', border: `1px solid ${duration === d ? '#2563EB' : '#E5E7EB'}`, background: duration === d ? '#EFF6FF' : '#FFFFFF' }}>{d} dtk</button>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 10, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, color: '#6B7280', minWidth: 150 }}>Mulai di {mmss(start)} lagu (sampai {mmss(start + duration)})</span>
        <input type="range" min="0" max={maxStart} value={start} onChange={e => setStartIn(Number(e.target.value))} style={{ flex: 1, minWidth: 160, padding: 0 }} />
      </div>
      <button className="btn btn-gold" onClick={create} disabled={busy || !info.canCreate || info.items.length >= info.max} style={{ fontSize: 12 }}>
        {busy ? 'Mengirim...' : '📱 Buat Shorts'}
      </button>
      {!info.canCreate && <div style={{ fontSize: 12, color: '#6B7280', marginTop: 6 }}>Berkas video kompilasi sudah tidak ada di server, jadi Shorts baru tidak bisa dibuat dari proyek ini.</div>}
      {err && <div style={{ fontSize: 12, color: '#DC2626', marginTop: 6 }}>{err}</div>}
      {info.items.length > 0 && (
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 12 }}>
          {info.items.map(it => (
            <div key={it.id} style={{ width: 150, background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: 8, padding: 6 }}>
              {it.status === 'ready'
                ? <video src={fileUrl(it.id)} controls preload="metadata" style={{ width: '100%', aspectRatio: '9 / 16', background: '#000', borderRadius: 6 }} />
                : <div style={{ width: '100%', aspectRatio: '9 / 16', background: '#111827', borderRadius: 6, color: '#9CA3AF', fontSize: 11, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 8 }}>
                    {it.status === 'processing' ? 'Sedang dibuat (±30 dtk)...' : `Gagal: ${it.error_message || ''}`}
                  </div>}
              <div style={{ fontSize: 11, marginTop: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{it.song_title} · {it.duration_sec} dtk</div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
                {it.status === 'ready' ? <a href={fileUrl(it.id, true)} style={{ fontSize: 11, color: '#2563EB' }}>Unduh</a> : <span />}
                <button onClick={() => remove(it.id)} style={{ background: 'transparent', border: 'none', color: '#DC2626', fontSize: 11, cursor: 'pointer', padding: 0 }}>Hapus</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Saran lagu & panjang kompilasi dari DNA (2026-10-07). Hanya membaca saran; menambah lagu
// memakai endpoint tambah-lagu yang sudah ada (POST /projects/:id/songs/url).
function DnaSongPanel({ projectId, defaultDnaId, songCount, onAdded }) {
  const [dnaList, setDnaList] = useState([]);
  const [dnaId, setDnaId] = useState(defaultDnaId || '');
  const [sug, setSug] = useState(null);
  const [open, setOpen] = useState(true);
  const [adding, setAdding] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    axios.get(`${API}/api/dna`, hdr())
      .then(r => {
        const ready = (r.data || []).filter(d => d.status === 'ready');
        setDnaList(ready);
        if (!defaultDnaId && ready.length === 1) setDnaId(ready[0].id);
      })
      .catch(() => {});
  }, [defaultDnaId]);

  useEffect(() => {
    if (!dnaId) { setSug(null); return; }
    axios.get(`${API}/api/ugc/projects/${projectId}/dna-suggestions?dna_id=${encodeURIComponent(dnaId)}`, hdr())
      .then(r => setSug(r.data))
      .catch(() => setSug(null));
  }, [dnaId, projectId, songCount]);

  async function addMatch(m) {
    setAdding(m.source_url); setErr('');
    try {
      await axios.post(`${API}/api/ugc/projects/${projectId}/songs/url`, { url: m.source_url, title: m.title }, hdr());
      onAdded();
    } catch (e) {
      setErr(e.response?.data?.error || 'Gagal menambah lagu');
    }
    setAdding('');
  }

  if (!dnaList.length) return null;
  const t = sug?.target, c = sug?.current;
  const short = t && c ? Math.max(0, t.songs - c.songs) : 0;
  const okLen = t && c && c.songs >= Math.round(t.songs * 0.8);

  return (
    <div style={{ background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: 10, padding: 12, marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <div style={{ fontSize: 13, fontWeight: 600 }}>Saran dari DNA</div>
        {/* flexWrap + maxWidth: nama channel DNA panjang dulu melebarkan baris ini melewati layar HP (2026-10-08). */}
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', minWidth: 0, maxWidth: '100%' }}>
          <select id="dna-song-dna" aria-label="DNA acuan" value={dnaId} onChange={e => setDnaId(e.target.value)}
            style={{ padding: '6px 10px', borderRadius: 8, fontSize: 12, width: 'auto', maxWidth: '100%', minWidth: 0 }}>
            <option value="">Pilih DNA acuan</option>
            {dnaList.map(d => <option key={d.id} value={d.id}>{d.channel_name || d.channel_url}</option>)}
          </select>
          {dnaId && (
            <button onClick={() => setOpen(v => !v)} style={{ background: 'transparent', border: 'none', color: '#6B7280', fontSize: 12, cursor: 'pointer', textDecoration: 'underline' }}>
              {open ? 'Sembunyikan' : 'Tampilkan'}
            </button>
          )}
        </div>
      </div>

      {dnaId && open && sug?.dna && (
        <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {t ? (
            <div style={{ fontSize: 12, lineHeight: 1.6, padding: '8px 10px', borderRadius: 8, background: okLen ? '#ECFDF5' : '#FFFBEB', color: okLen ? '#047857' : '#92400E' }}>
              <b>Panjang kompilasi.</b> {sug.dna.name} rata-rata {t.minutes} menit, sekitar {t.songs} lagu
              {t.songLengthKnown ? ` (${String(t.avgSongMin).replace('.', ',')} menit per lagu)` : ''}.
              {' '}Proyek ini {c.songs} lagu, {c.estimated ? 'perkiraan ' : ''}{c.minutes} menit.
              {okLen ? ' Panjangnya sudah sesuai pola.' : ` Tambah sekitar ${short} lagu lagi supaya sesuai pola.`}
            </div>
          ) : (
            <div style={{ fontSize: 12, color: '#6B7280' }}>Channel acuan ini bukan channel kompilasi, jadi tidak ada target panjang.</div>
          )}

          <div>
            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Lagu yang sering dipakai di video laris {sug.dna.name}</div>
            {sug.needsRefresh ? (
              <div style={{ fontSize: 12, color: '#6B7280' }}>Data DNA ini dibuat sebelum fitur lagu ada. Perbarui datanya di menu DNA Channel (tombol putar) untuk melihat daftar lagu.</div>
            ) : !sug.hotSongs?.length ? (
              <div style={{ fontSize: 12, color: '#6B7280' }}>Channel acuan ini tidak menulis nama lagu di judul atau deskripsinya, jadi daftar lagunya tidak bisa dibaca.</div>
            ) : (
              <>
                <div style={{ fontSize: 11, color: '#6B7280', marginBottom: 6 }}>
                  "Tambah" muncul kalau lagu itu pernah kamu pakai di proyek lain. Selain itu, cari versi yang kamu punya haknya di YouTube lalu tempel link-nya di bawah.
                </div>
                <div style={{ border: '1px solid #E5E7EB', borderRadius: 8 }}>
                  {sug.hotSongs.slice(0, 12).map((h, i) => (
                    <div key={h.title} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 10px', borderTop: i ? '1px solid #E5E7EB' : 'none', flexWrap: 'wrap' }}>
                      <div style={{ flex: 1, minWidth: 160 }}>
                        <div style={{ fontSize: 12, fontWeight: 600 }}>{h.title}</div>
                        <div style={{ fontSize: 11, color: '#6B7280' }}>
                          dipakai di {h.videos} video{h.matches.length ? ` · pernah kamu pakai: ${h.matches[0].title}` : ''}
                        </div>
                      </div>
                      {h.matches.length ? (
                        <button onClick={() => addMatch(h.matches[0])} disabled={!!adding || songCount >= 30} className="btn btn-gold"
                          style={{ fontSize: 11, padding: '5px 10px', opacity: (adding || songCount >= 30) ? 0.6 : 1 }}>
                          {adding === h.matches[0].source_url ? '...' : '+ Tambah'}
                        </button>
                      ) : (
                        <a href={h.youtubeSearch} target="_blank" rel="noopener noreferrer"
                          style={{ fontSize: 11, color: '#2563EB', textDecoration: 'none', whiteSpace: 'nowrap' }}>Cari di YouTube ↗</a>
                      )}
                    </div>
                  ))}
                </div>
                {err && <div style={{ fontSize: 12, color: '#DC2626', marginTop: 6 }}>{err}</div>}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function UgcDetail({ projectId, onBack, onOpen, flash }) {
  // Toggle admin (2026-10-08): sumber dari URL OFF → lagu hanya lewat upload berkas / gudang lagu.
  const { client: authClient } = useAuth();
  const urlOn = !!authClient?.url_source_enabled;
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');
  const [songUrl, setSongUrl] = useState('');
  const [songTitle, setSongTitle] = useState('');
  const [adding, setAdding] = useState(false);
  const [uploadingVisual, setUploadingVisual] = useState(false);
  const [channels, setChannels] = useState([]);
  const [selChannels, setSelChannels] = useState([]);
  const [campGroups, setCampGroups] = useState([]); // grup channel dari halaman Campaign
  const [processing, setProcessing] = useState(false);
  const [approving, setApproving] = useState(false);
  const [approveMsg, setApproveMsg] = useState(null); // pesan tepat di bawah tombol Setujui (msg di atas halaman sering tak terlihat)
  const [scheduledAt, setScheduledAt] = useState('');
  // Jadwal bertahap / acak per channel (2026-10-11) — sama dengan form Shorts.
  const [rencanaJadwal, setRencanaJadwal] = useState([]);
  const [uploadingThumb, setUploadingThumb] = useState(false);
  // Deklarasi YouTube, dikirim bersama permintaan proses video.
  const [madeForKids, setMadeForKids] = useState(false);
  const [sizeCap, setSizeCap] = useState(false);
  const [minDur, setMinDur] = useState(0);
  const [containsAi, setContainsAi] = useState(false);
  const [deletingVideo, setDeletingVideo] = useState(false);
  const [deletingProject, setDeletingProject] = useState(false);
  const [showBgGenerator, setShowBgGenerator] = useState(false);
  const [showThumbGenerator, setShowThumbGenerator] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const logBoxRef = useRef(null);

  useEffect(() => {
    if (logBoxRef.current) logBoxRef.current.scrollTop = logBoxRef.current.scrollHeight;
  }, [data?.progress_log]);

  useEffect(() => { load(); loadChannels(); setMsg(flash || ''); }, [projectId]); // eslint-disable-line

  // Unduhan awal lagu (2026-10-08): selama proyek draft dan masih ada lagu yang antre/diunduh,
  // segarkan status tiap 5 detik supaya label per lagu ikut berubah.
  const songsPreparing = data?.status === 'draft' && (data.songs || []).some(s => s.status === 'prefetching' || (s.status === 'pending' && !String(s.error_message || '').startsWith('prefetch:')));
  useEffect(() => {
    if (!songsPreparing) return undefined;
    const t = setTimeout(silentLoad, 5000);
    return () => clearTimeout(t);
  }, [songsPreparing, data]); // eslint-disable-line

  // Auto-refresh tiap 3 detik selama status 'processing' — supaya client lihat progress
  // terkini, bukan cuma spinner statis yang tidak pernah update. Pakai silentLoad
  // (tanpa toggle `loading`) supaya halaman tidak flash tiap poll.
  async function silentLoad() {
    try {
      const r = await axios.get(`${API}/api/ugc/projects/${projectId}`, hdr());
      setData(r.data);
    } catch (e) {}
  }

  const pollAwaiting = data?.status === 'ready' && (data.channels || []).length > 0 && (data.channels || []).every(c => c.status === 'scheduled');
  useEffect(() => {
    if (data?.status !== 'processing' && data?.status !== 'distributing' && !pollAwaiting) return;
    const t = setInterval(silentLoad, 3000);
    return () => clearInterval(t);
  }, [data?.status, pollAwaiting, projectId]);

  async function load() {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/api/ugc/projects/${projectId}`, hdr());
      setData(r.data);
      setSelChannels((r.data.channels || []).map(c => c.channel_id));
      setMadeForKids(!!r.data.made_for_kids);
      setContainsAi(!!r.data.contains_synthetic_media);
      setSizeCap(!!r.data.size_cap);
      setMinDur(r.data.min_duration_sec ? Math.round(r.data.min_duration_sec / 60) : 0);
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal memuat proyek');
    }
    setLoading(false);
  }

  async function loadChannels() {
    try {
      const r = await axios.get(`${API}/api/youtube/channels`, hdr());
      setChannels(r.data || []);
    } catch (e) {}
  }

  async function addSongUrl() {
    if (!songUrl.trim()) return;
    setAdding(true);
    try {
      await axios.post(`${API}/api/ugc/projects/${projectId}/songs/url`,
        { url: songUrl.trim(), title: songTitle.trim() || null }, hdr());
      setSongUrl(''); setSongTitle('');
      load();
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal menambah lagu');
    }
    setAdding(false);
  }

  async function uploadAudio(file) {
    if (!file) return;
    setAdding(true);
    const fd = new FormData();
    fd.append('audio', file);
    try {
      await axios.post(`${API}/api/ugc/projects/${projectId}/songs/upload`, fd, {
        headers: { ...hdr().headers, 'Content-Type': 'multipart/form-data' }
      });
      load();
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal upload audio');
    }
    setAdding(false);
  }

  async function uploadVisual(file) {
    if (!file) return;
    setUploadingVisual(true);
    const fd = new FormData();
    fd.append('visual', file);
    try {
      await axios.post(`${API}/api/ugc/projects/${projectId}/visual`, fd, {
        headers: { ...hdr().headers, 'Content-Type': 'multipart/form-data' }
      });
      load();
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal upload visual');
    }
    setUploadingVisual(false);
  }
  async function deleteVideoOnly() {
    if (!window.confirm('Hapus video ini? Histori dan riwayat lagu tetap tersimpan.')) return;
    setDeletingVideo(true);
    try {
      await axios.delete(`${API}/api/ugc/projects/${projectId}/video`, hdr());
      load();
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal hapus video');
    }
    setDeletingVideo(false);
  }
  async function deleteProjectFull() {
    if (!window.confirm('Hapus SELURUH proyek ini secara permanen? Histori, riwayat lagu, dan video akan hilang total. Tindakan ini tidak bisa dibatalkan.')) return;
    setDeletingProject(true);
    try {
      await axios.delete(`${API}/api/ugc/projects/${projectId}`, hdr());
      onBack();
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal hapus proyek');
      setDeletingProject(false);
    }
  }
  async function removeSong(songId) {
    try {
      await axios.delete(`${API}/api/ugc/songs/${songId}`, hdr());
      load();
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal menghapus lagu');
    }
  }

  // Ceklis channel cuma state lokal sampai disimpan ke server. Return true/false supaya
  // approve() bisa memanggilnya dulu — user sering langsung klik "Setujui" tanpa klik
  // "Simpan Channel Tujuan", lalu server jawab 400 "belum ada channel tujuan".
  async function saveChannels({ quiet } = {}) {
    try {
      await axios.put(`${API}/api/ugc/projects/${projectId}/channels`,
        { channel_ids: selChannels, campaign_id: (matchCampaign(campGroups, selChannels) || {}).id || null }, hdr());
      if (!quiet) { setMsg('Channel tujuan tersimpan'); setTimeout(() => setMsg(''), 2500); }
      return true;
    } catch (e) {
      const err = e.response?.data?.error || 'Gagal menyimpan channel';
      setMsg(err); setApproveMsg({ ok: false, text: err });
      return false;
    }
  }

  // Ceklis di layar sudah sama dengan yang tersimpan di server?
  function channelsSaved() {
    const saved = (data?.channels || []).map(c => c.channel_id).sort();
    const sel = [...selChannels].sort();
    return saved.length === sel.length && saved.every((id, i) => id === sel[i]);
  }

  async function startProcess() {
    setProcessing(true);
    try {
      await axios.post(`${API}/api/ugc/projects/${projectId}/process`,
        { made_for_kids: madeForKids, contains_synthetic_media: containsAi, size_cap: sizeCap, min_duration_min: minDur }, hdr());
      setMsg('Proyek masuk antrian proses — cek beberapa saat lagi');
      load();
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal memulai proses');
    }
    setProcessing(false);
  }

  async function approve() {
    setApproving(true); setApproveMsg(null);
    try {
      // Simpan ceklis channel dulu kalau belum sama dengan yang di server (satu klik cukup).
      if (!channelsSaved() && !(await saveChannels({ quiet: true }))) { setApproving(false); return; }
      const r = await axios.post(`${API}/api/ugc/projects/${projectId}/approve`,
        { scheduled_at: rencanaJadwal.length ? null : (scheduledAt || null),
          channel_schedules: rencanaJadwal.map(r => ({ channel_id: r.channel_id, scheduled_at: r.scheduled_at || null, offset_min: r.offset_min ?? null })) }, hdr());
      const ok = r.data.message || 'Video dijadwalkan';
      setMsg(ok); setApproveMsg({ ok: true, text: ok });
      load();
    } catch (e) {
      const err = e.response?.data?.error || 'Gagal menyetujui distribusi';
      setMsg(err); setApproveMsg({ ok: false, text: err });
    }
    setApproving(false);
  }

  if (loading || !data) return <div className="loading"><div className="spinner" /></div>;

  // 'failed' itu ambigu: bisa render-nya yang gagal (belum ada video sama sekali,
  // perlu diproses ulang) atau video-nya sudah jadi tapi upload ke channel yang gagal
  // (perlu retry distribusi, BUKAN render ulang dari nol). Bedakan lewat rendered_path.
  const distributionFailed = data.status === 'failed' && !!data.rendered_path;
  const renderFailed = data.status === 'failed' && !data.rendered_path;
  const canProcess = data.status === 'draft' || renderFailed;
  // Sudah disetujui tapi scheduler belum mengambil (tick ≤ 60 dtk): job masih 'ready' dengan
  // semua channel 'scheduled'. Jangan tampilkan picker/tombol Setujui lagi — klik ulang cuma
  // dapat 400 "belum ada channel tujuan yang menunggu".
  const chRows = data.channels || [];
  const awaitingUpload = data.status === 'ready' && chRows.length > 0 && chRows.every(c => c.status === 'scheduled');
  const canApprove = (data.status === 'ready' || distributionFailed) && !awaitingUpload;
  const needSongs = (data.status === 'draft' || renderFailed) && !(data.songs || []).length;
  const showPreview = !!data.rendered_path && (data.status === 'ready' || data.status === 'distributing' || data.status === 'done' || distributionFailed);
  // Channel tujuan baru dipilih SETELAH video siap (ready) — satu langkah, langsung disimpan
  // saat klik Setujui. Di tahap draft tidak diminta, render tidak butuh channel.
  const showChannelPicker = (data.status === 'ready' || distributionFailed) && !awaitingUpload;
  const hasScheduledChannels = (data.channels || []).some(c => c.status !== 'pending');
  const showChannelStatus = data.status === 'distributing' || data.status === 'done' || distributionFailed || hasScheduledChannels;

  const isFile = data.source_type === 'file';
  if (isFile && data.status === 'draft') {
    return (
      <div>
        <div onClick={onBack} style={{ fontSize: 13, color: '#6B7280', cursor: 'pointer', marginBottom: 16 }}>← Kembali ke daftar proyek</div>
        <h1 style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>{data.title || 'Video jadi'}</h1>
        <div style={{ padding: '12px 14px', borderRadius: 10, background: 'rgba(251,191,36,0.12)', color: '#92400E', fontSize: 13 }}>
          Upload video belum selesai (halaman sempat ditutup atau koneksi terputus). Hapus proyek ini dari daftar lalu unggah ulang lewat "📁 Upload Video Jadi".
        </div>
      </div>
    );
  }

  return (
    <div>
      <div onClick={onBack} style={{ fontSize: 13, color: '#6B7280', cursor: 'pointer', marginBottom: 16 }}>
        ← Kembali ke daftar proyek
      </div>

      <h1 style={{ fontSize: 22, fontWeight: 800, marginBottom: 4 }}>{data.title || 'Proyek Kompilasi'}</h1>
      <div style={{ fontSize: 12, color: STATUS_COLOR[data.status], fontWeight: 600, marginBottom: 20 }}>
        {distributionFailed ? 'Video siap, upload gagal' : (STATUS_LABEL[data.status] || data.status)}
      </div>
      {isFile && (
        <div style={{ display: 'inline-block', fontSize: 11.5, fontWeight: 600, color: '#1D4ED8', background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: 999, padding: '3px 10px', marginTop: -12, marginBottom: 16 }}>
          📁 Video dari file jadi — tanpa render{data.duration_sec ? ` · ${Math.floor(data.duration_sec / 60)} mnt ${data.duration_sec % 60} dtk` : ''}
        </div>
      )}

      {data.trend_ref && (
        <div style={{ display: 'inline-block', fontSize: 11.5, fontWeight: 600, color: '#C2410C', background: '#FFF7ED', border: '1px solid #FED7AA', borderRadius: 999, padding: '3px 10px', marginTop: -12, marginBottom: 16, maxWidth: '100%', overflowWrap: 'anywhere' }}>
          📈 Dari Trending: {String(data.trend_ref.title || '').slice(0, 80)}{data.trend_ref.cc ? ' · Creative Commons (kredit otomatis di deskripsi)' : ' · acuan judul & tags'}
        </div>
      )}

      {data.status !== 'processing' && (data.songs || []).length > 0 && onOpen && (
        <RemakeBar projectId={projectId} songCount={(data.songs || []).length} onOpen={onOpen} />
      )}
      {data.status !== 'processing' && (data.songs || []).length > 0 && onOpen && authClient?.features?.ugc_batch !== false && (
        <BatchBar key={projectId} projectId={projectId} songCount={(data.songs || []).length} sourceChannels={data.channels} onOpen={onOpen} />
      )}

      {msg && (
        <div style={{ padding: '10px 16px', marginBottom: 18, borderRadius: 12,
          background: '#F3F4F6', color: '#111827', border: '1px solid #E5E7EB', fontSize: 13 }}>{msg}</div>
      )}

      {showPreview && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>Preview</div>
          <video controls style={{ width: '100%', borderRadius: 12, background: '#000' }}
            src={`${API}/api/ugc/preview/${projectId}?token=${localStorage.getItem('sm_token')}`} />
          <div style={{ marginTop: 10, fontSize: 12, color: '#6B7280', whiteSpace: 'pre-wrap' }}>
            {data.description}
          </div>
          <button onClick={deleteVideoOnly} disabled={deletingVideo}
            style={{ marginTop: 10, padding: '6px 14px', background: 'transparent', border: '1px solid rgba(239,68,68,0.4)', color: '#DC2626', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>
            {deletingVideo ? '...' : '🗑️ Hapus Video Saja (histori tetap tersimpan)'}
          </button>
        </div>
      )}
      {showPreview && data.rendered_path && !isFile && <ShortsPanel projectId={projectId} songs={data.songs || []} />}

      {(data.status === 'draft' || renderFailed) && (
        <>
          {urlOn && <DnaSongPanel projectId={projectId} defaultDnaId={data.dna_id} songCount={(data.songs || []).length} onAdded={load} />}
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>
            1. Pilih lagu ({(data.songs || []).length}/30)
          </div>
          <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 10 }}>
            {urlOn ? 'Masukkan lagu dulu (link YouTube atau file audio). Lagu dari link langsung diunduh di belakang layar selagi kamu mengatur tampilan, jadi proses video nanti lebih cepat.'
              : 'Masukkan lagu dulu: unggah file audio milikmu, atau pilih dari lagu yang pernah dipakai.'}
          </div>
          {(data.songs || []).length > 0 && <TidyTitlesPanel projectId={projectId} onDone={silentLoad} />}
          {(data.songs || []).map(s => (
            <SongTitleRow key={s.id} song={s} onSaved={silentLoad} onRemove={() => removeSong(s.id)} />
          ))}

          <div style={{ marginTop: 12 }}>
            <button className="btn btn-outline" style={{ fontSize: 12, marginBottom: showHistory ? 8 : 0 }} onClick={() => setShowHistory(v => !v)}>
              {showHistory ? 'Tutup daftar lagu lama' : '📚 Pilih dari lagu yang pernah dipakai'}
            </button>
            {showHistory && <SongHistoryPanel projectId={projectId} songCount={(data.songs || []).length} onAdded={silentLoad} />}
          </div>
          {urlOn && <div style={{ display: 'flex', gap: 8, marginTop: 12, marginBottom: 8, flexWrap: 'wrap' }}>
            <input placeholder="Judul (opsional)" value={songTitle} onChange={e => setSongTitle(e.target.value)}
              style={{ flex: '1 1 140px', fontSize: 12 }} />
            <input placeholder="https://youtube.com/watch?v=..." autoFocus={(data.songs || []).length === 0} value={songUrl} onChange={e => setSongUrl(e.target.value)}
              style={{ flex: '2 1 220px', fontSize: 12 }} />
            <button className="btn btn-outline" disabled={adding} onClick={addSongUrl}>+ URL</button>
          </div>}
          {!urlOn && <div style={{ height: 12 }} />}
          <label className="btn btn-outline" style={{ display: 'inline-block', cursor: 'pointer', fontSize: 12 }}>
            {adding ? '...' : '+ Upload File Audio'}
            <input type="file" accept=".mp3,.m4a,.wav" style={{ display: 'none' }}
              onChange={e => { uploadAudio(e.target.files[0]); e.target.value = ''; }} />
          </label>
          <div style={{ height: 20 }} />
        </>
      )}

      {(data.status === 'draft' || renderFailed) && (
        <div style={{ background: '#F3F4F6', padding: 14, borderRadius: 10, marginBottom: 14 }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>
            2. Latar video (opsional) {data.visual_mode === 'loop' ? '· Video Loop' : '· Gambar Still'}
          </div>
          {data.visual_asset ? (
            <div style={{ fontSize: 12, color: '#059669', marginBottom: 10 }}>✓ Sudah ada background terpasang</div>
          ) : (
            <div style={{ fontSize: 12, color: '#D97706', marginBottom: 10 }}>Belum ada background — pakai template default kalau tidak diisi</div>
          )}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <label className="btn btn-outline" style={{ display: 'inline-block', cursor: 'pointer', fontSize: 12 }}>
              {uploadingVisual ? '...' : (data.visual_asset ? 'Ganti File (Upload Manual)' : '+ Upload File Manual')}
              <input type="file" accept="video/*,image/*" style={{ display: 'none' }}
                onChange={e => { uploadVisual(e.target.files[0]); e.target.value = ''; }} />
            </label>
            <button onClick={() => setShowBgGenerator(v => !v)} className="btn btn-gold" style={{ fontSize: 12 }}>
              {showBgGenerator ? 'Tutup Generator AI' : '✨ Generate dengan AI'}
            </button>
          </div>
          {showBgGenerator && (
            <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid #E5E7EB' }}>
              <AiGeneratorPanel mode="ugc_bg" projectId={projectId} onAttached={() => { load(); setShowBgGenerator(false); }} />
            </div>
          )}
        </div>
      )}
      {/* Editor tampilan UGC (2026-10-08): posisi teks, font, gerak latar, urutan lagu. Tidak ada untuk proyek file jadi. */}
      {!isFile && <div style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', padding: 14, borderRadius: 10, marginBottom: 14, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 220 }}>
          <div style={{ fontSize: 13, fontWeight: 600 }}>{(data.status === 'draft' || renderFailed) ? '3. Atur tampilan video' : 'Tampilan video'}</div>
          <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>
            {needSongs
              ? 'Tambahkan minimal 1 lagu dulu: judul-judul lagu otomatis muncul di editor.'
              : data.scene
              ? 'Memakai editor: posisi teks, font, dan gerak latar sesuai pengaturanmu.'
              : 'Masih tampilan bawaan. Buka editor untuk menggeser teks, memilih font, gerak latar, dan mengatur urutan lagu.'}
          </div>
        </div>
        <button onClick={() => navigate(`/ugc/editor/${projectId}`)} disabled={needSongs} className="btn btn-gold" style={{ fontSize: 12, opacity: needSongs ? 0.5 : 1 }}>
          {(data.status === 'draft' || renderFailed) ? '🎨 Buka editor tampilan' : 'Lihat tampilan'}
        </button>
      </div>}
      {/* Thumbnail juga bisa diganti saat video siap & belum disetujui (canApprove): tracklist sudah final. */}
      {(data.status === 'draft' || renderFailed || canApprove) && (
        <div style={{ background: '#F3F4F6', padding: 14, borderRadius: 10, marginBottom: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>Thumbnail YouTube</div>
          {data.thumbnail_url ? (
            <img src={`${API}${data.thumbnail_url}`} alt="Thumbnail terpasang" style={{ width: '100%', maxWidth: 360, aspectRatio: '16/9', objectFit: 'cover', borderRadius: 8, display: 'block', marginBottom: 10 }} />
          ) : (
            <div style={{ fontSize: 12, color: '#D97706', marginBottom: 10 }}>Belum ada thumbnail custom — YouTube pakai thumbnail otomatis</div>
          )}
          <label className="btn btn-outline" style={{ fontSize: 12, cursor: 'pointer', marginRight: 8, marginBottom: 8, display: 'inline-block' }}>
            {uploadingThumb ? 'Mengunggah…' : '🖼️ Unggah gambar sendiri'}
            <input type="file" accept="image/jpeg,image/png,image/webp" style={{ display: 'none' }} disabled={uploadingThumb}
              onChange={async e => {
                const f = e.target.files[0]; e.target.value = ''; if (!f) return;
                setUploadingThumb(true);
                try { const fd = new FormData(); fd.append('image', f); await axios.post(`${API}/api/ugc/projects/${projectId}/thumbnail-upload`, fd, hdr()); load(); }
                catch (err) { setMsg(err.response?.data?.error || 'Gagal mengunggah thumbnail'); }
                setUploadingThumb(false);
              }} />
          </label>
          {!isFile && <DnaThumbPanel projectId={projectId} defaultDnaId={data.dna_id} onDone={load} />}
          <button onClick={() => setShowThumbGenerator(v => !v)} className="btn btn-gold" style={{ fontSize: 12 }}>
            {showThumbGenerator ? 'Tutup Generator AI' : '✨ Generate Thumbnail dengan AI'}
          </button>
          {showThumbGenerator && (
            <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid #E5E7EB' }}>
              <AiGeneratorPanel mode="thumbnail" projectId={projectId} onAttached={() => { load(); setShowThumbGenerator(false); }} />
            </div>
          )}
        </div>
      )}
      {['draft', 'ready', 'failed'].includes(data.status) && (
        <SeoTagPanel projectId={projectId} data={data} full={!!data.rendered_path && data.status !== 'draft'} onSaved={silentLoad} />
      )}
      {showChannelPicker && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', margin: '24px 0 10px' }}>
            <div style={{ fontSize: 13, fontWeight: 600, flex: 1 }}>
              Pilih Channel Tujuan ({selChannels.length}/{Math.min(100, channels.length) || 100})
            </div>
            {/* 2026-10-10: "Pilih semua" & "Kosongkan" terpisah supaya pilihan campaign bisa dibatalkan. */}
            {channels.length > 1 && selChannels.length < Math.min(100, channels.length) && (
              <span onClick={() => setSelChannels(channels.slice(0, 100).map(c => c.id))}
                style={{ fontSize: 12, color: '#2563EB', cursor: 'pointer' }}>
                {`Pilih semua (${Math.min(100, channels.length)})`}
              </span>
            )}
            {selChannels.length > 0 && (
              <span onClick={() => setSelChannels([])} style={{ fontSize: 12, color: '#2563EB', cursor: 'pointer' }}>Kosongkan</span>
            )}
          </div>
          <CampaignPicker channels={channels} selected={selChannels} onPick={ids => setSelChannels(ids)} onGroups={setCampGroups} />
          {selChannels.length === 0 && (
            <div style={{ padding: '9px 12px', marginBottom: 10, borderRadius: 8, fontSize: 12.5,
              background: 'rgba(251,191,36,0.12)', color: '#D97706' }}>
              Video sudah siap. Ceklis channel tujuan di bawah, lalu klik Setujui — channel tersimpan otomatis.
            </div>
          )}
          {distributionFailed && (
            <div style={{ padding: '9px 12px', marginBottom: 10, borderRadius: 8, fontSize: 12.5,
              background: 'rgba(239,68,68,0.12)', color: '#DC2626' }}>
              Video sudah jadi, tapi upload sebelumnya gagal (lihat status per-channel di bawah). Pilih ulang channel tujuan lalu setujui lagi untuk retry — video TIDAK akan dirender ulang.
            </div>
          )}
          {channels.length === 0 ? (
            <div style={{ color: '#6B7280', fontSize: 13 }}>Belum ada channel terhubung.</div>
          ) : channels.map(ch => {
            const on = selChannels.includes(ch.id);
            return (
              <label key={ch.id} style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '8px 11px',
                background: on ? 'rgba(255,87,34,0.10)' : '#F3F4F6',
                border: '1px solid ' + (on ? 'rgba(255,87,34,0.32)' : '#E5E7EB'),
                borderRadius: 9, cursor: 'pointer', fontSize: 12.5, marginBottom: 6 }}>
                <input type="checkbox" checked={on} style={{ width: 15, height: 15, margin: 0 }} disabled={!on && selChannels.length >= 100}
                  onChange={e => setSelChannels(p => e.target.checked ? (p.length >= 100 ? p : [...p, ch.id]) : p.filter(x => x !== ch.id))} />
                {ch.channel_name || 'Channel'}
              </label>
            );
          })}
        </>
      )}

      {(data.status === 'draft' || renderFailed) && (
        <div style={{ margin: '14px 0', padding: '12px 14px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 10 }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, marginBottom: 8 }}>Deklarasi YouTube</div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, marginBottom: 7, cursor: 'pointer' }}>
            <input type="checkbox" checked={madeForKids} onChange={e => setMadeForKids(e.target.checked)}
              style={{ width: 15, height: 15, margin: 0 }} />
            Video ini dibuat untuk anak-anak
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, cursor: 'pointer' }}>
            <input type="checkbox" checked={containsAi} onChange={e => setContainsAi(e.target.checked)}
              style={{ width: 15, height: 15, margin: 0 }} />
            Mengandung konten yang dibuat/diubah dengan AI
          </label>
          <div style={{ fontSize: 11, opacity: 0.7, marginTop: 8, lineHeight: 1.5 }}>
            Wajib diisi sesuai keadaan sebenarnya — YouTube memakai deklarasi ini untuk kepatuhan hukum perlindungan anak.
          </div>
        </div>
      )}

      {(data.status === 'draft' || renderFailed) && (() => {
        // Durasi minimum (2026-10-22): perkiraan sama dengan buildPlayOrder di API (lagu utuh, diulang dari awal).
        const durs = (data.songs || []).map(x => Number(x.duration_sec) || 0);
        const total = durs.reduce((a, b) => a + b, 0);
        const known = durs.length > 0 && durs.every(d => d > 0);
        let plays = durs.length, est = total;
        if (minDur > 0 && known) { for (let k = 0; est < minDur * 60 && plays < 300; k++) { est += durs[k % durs.length]; plays++; } }
        const mnt = v => `${Math.floor(v / 60)} mnt${v % 60 ? ` ${Math.round(v % 60)} dtk` : ''}`;
        return (
          <div style={{ margin: '14px 0', padding: '12px 14px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 10 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, marginBottom: 8 }}>Durasi video</div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, flexWrap: 'wrap' }}>
              Durasi minimal
              <select value={minDur} onChange={e => setMinDur(Number(e.target.value))} style={{ padding: '5px 8px', borderRadius: 7, border: '1px solid #D1D5DB' }}>
                <option value={0}>Tanpa minimum</option>
                {[30, 45, 60, 90, 120, 180].map(m => <option key={m} value={m}>{m >= 60 && m % 60 === 0 ? `${m / 60} jam` : `${m} menit`}</option>)}
              </select>
            </label>
            <div style={{ fontSize: 11, opacity: 0.75, marginTop: 8, lineHeight: 1.5 }}>
              {minDur === 0
                ? <>Durasi mengikuti jumlah lagu{known ? ` (±${mnt(total)})` : ''}.</>
                : !known ? <>Kalau total lagu kurang dari {minDur} menit, daftar lagu diputar ulang dari awal sampai durasinya tercapai.</>
                : plays > durs.length
                  ? <>Total lagu ±{mnt(total)}, jadi daftar lagu diputar ulang dari awal: <b>{plays} putaran lagu, ±{mnt(est)}</b>. Lagu tidak dipotong; daftar di layar tetap {durs.length} lagu.</>
                  : <>Total lagu ±{mnt(total)} sudah lebih dari {minDur} menit, tidak ada pengulangan.</>}
            </div>
          </div>
        );
      })()}

      {(data.status === 'draft' || renderFailed) && (
        <div style={{ margin: '14px 0', padding: '12px 14px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 10 }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, marginBottom: 8 }}>Ukuran file</div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, cursor: 'pointer' }}>
            <input type="checkbox" checked={sizeCap} onChange={e => setSizeCap(e.target.checked)}
              style={{ width: 15, height: 15, margin: 0 }} />
            Batasi ukuran video maksimal 1,5 GB
          </label>
          <div style={{ fontSize: 11, opacity: 0.7, marginTop: 8, lineHeight: 1.5 }}>
            Upload ke banyak channel jadi lebih cepat dan hemat. Kalau hasil render lebih dari 1,5 GB, video di-encode ulang:
            proses bertambah ±20 menit per jam video dan kualitas gambar sedikit turun. Resolusi, FPS dan audio tidak berubah.
          </div>
        </div>
      )}

      {(data.status === 'draft' || renderFailed) && (
        <button className="btn btn-gold" disabled={!canProcess || processing} onClick={startProcess} style={{ width: '100%' }}>
          {processing ? 'Memulai...' : '▶ Proses Video'}
        </button>
      )}

      {showChannelStatus && (
        <div style={{ margin: '20px 0' }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>Status Upload per Channel</div>
          {(data.channels || []).length === 0 ? (
            <div style={{ color: '#6B7280', fontSize: 13 }}>Belum ada channel tujuan.</div>
          ) : (data.channels || []).map(c => (
            <div key={c.id} style={{ padding: '9px 12px', background: '#F3F4F6',
              borderRadius: 8, marginBottom: 6 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 12.5 }}>{c.channel_name || 'Channel'}</span>
                <span style={{ fontSize: 11, fontWeight: 600, color: CHANNEL_STATUS_COLOR[c.status] || '#6B7280' }}>
                  {c.status === 'scheduled' && c.scheduled_at && new Date(c.scheduled_at) <= new Date() ? 'Antre upload — mulai otomatis ≤ 1 menit' : (CHANNEL_STATUS_LABEL[c.status] || c.status)}
                </span>
              </div>
              {c.status === 'scheduled' && c.scheduled_at && new Date(c.scheduled_at) > new Date() && (
                <div style={{ fontSize: 11, color: '#6B7280', marginTop: 4 }}>
                  Terjadwal: {new Date(c.scheduled_at).toLocaleString('id-ID', {
                    timeZone: 'Asia/Jakarta', dateStyle: 'medium', timeStyle: 'short'
                  })} WIB
                </div>
              )}
              {c.status === 'done' && c.youtube_video_id && (
                <a href={`https://youtu.be/${c.youtube_video_id}`} target="_blank" rel="noreferrer"
                  style={{ fontSize: 11, color: '#1D4ED8' }}>youtu.be/{c.youtube_video_id}</a>
              )}
              {c.error_message && (
                <div style={{ fontSize: 11, color: '#DC2626', marginTop: 4 }}>{c.error_message}</div>
              )}
            </div>
          ))}
        </div>
      )}

      {awaitingUpload && (
        <div style={{ padding: '9px 12px', margin: '10px 0', borderRadius: 8, fontSize: 12.5,
          background: 'rgba(16,185,129,0.12)', color: '#059669' }}>
          ✓ Sudah disetujui — upload dimulai otomatis sesuai jadwal di atas (jadwal kosong = ≤ 1 menit). Halaman ini auto-refresh.
        </div>
      )}

      {data.status === 'distributing' && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '10px 0', color: '#6B7280', fontSize: 13 }}>
          <div className="spinner" style={{ width: 16, height: 16 }} />
          Sedang upload ke channel — halaman ini auto-refresh tiap 3 detik, tidak perlu di-reload manual.
        </div>
      )}

      {data.status === 'processing' && (
        <div style={{ padding: '16px 0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, color: '#6B7280', fontSize: 13 }}>
            <div className="spinner" style={{ width: 16, height: 16 }} />
            Sedang memproses — bisa beberapa menit tergantung jumlah lagu.
          </div>
          <div ref={logBoxRef} style={{
            background: '#0b0f1c', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8,
            padding: '10px 12px', fontFamily: 'monospace', fontSize: 11.5, color: '#9be69b',
            maxHeight: 240, overflowY: 'auto', whiteSpace: 'pre-wrap', textAlign: 'left'
          }}>
            {data.progress_log || 'Menunggu proses dimulai...'}
          </div>
        </div>
      )}

      {['ready', 'failed', 'distributing', 'done'].includes(data.status) && !awaitingUpload && <SosialUgc projectId={projectId} data={data} />}
      {/* Persetujuan tim (2026-10-21): editor mengajukan, ketua tim (admin) menyetujui di menu Persetujuan. */}
      {canApprove && data.persetujuan === 'menunggu' && (
        <div style={{ padding: '9px 12px', margin: '10px 0', borderRadius: 8, fontSize: 12.5, background: 'rgba(217,119,6,0.12)', color: '#B45309' }}>
          ⏳ {data.saya_editor
            ? 'Menunggu persetujuan ketua tim. Video dijadwalkan otomatis setelah disetujui. Kamu masih bisa mengubah jadwal lalu klik "Perbarui pengajuan".'
            : 'Diajukan oleh editor — setujui/tolak di menu Persetujuan, atau langsung jadwalkan di sini (dihitung sebagai disetujui).'}
        </div>
      )}
      {canApprove && data.persetujuan === 'ditolak' && (
        <div style={{ padding: '9px 12px', margin: '10px 0', borderRadius: 8, fontSize: 12.5, background: 'rgba(239,68,68,0.12)', color: '#DC2626' }}>
          ✕ Pengajuan ditolak ketua tim{data.alasan_tolak ? `: ${data.alasan_tolak}` : '.'}{data.saya_editor ? ' Perbaiki lalu ajukan ulang.' : ''}
        </div>
      )}
      {canApprove && (
        <div style={{ marginTop: 10 }}>
          <JadwalKirim channels={channels.filter(c => selChannels.includes(c.id))} onChange={setRencanaJadwal} relatifLabel={data.saya_editor ? 'setelah disetujui ketua tim' : 'setelah klik Setujui'} />
          {rencanaJadwal.length === 0 && (
            <>
              <div style={{ fontSize: 12.5, color: '#6B7280', marginBottom: 6 }}>
                Atau satu jam untuk semua channel (opsional — kosongkan untuk upload sekarang):
              </div>
              <input type="datetime-local" value={scheduledAt} onChange={e => setScheduledAt(e.target.value)}
                style={{ marginBottom: 10, width: '100%' }} />
            </>
          )}
          <button className="btn btn-gold" disabled={approving || selChannels.length === 0} onClick={approve} style={{ width: '100%' }}>
            {data.saya_editor
              ? (approving ? 'Mengajukan...' : data.persetujuan === 'menunggu' ? '↻ Perbarui pengajuan' : '✓ Ajukan ke ketua tim')
              : approving ? 'Menjadwalkan...' : (rencanaJadwal.length || scheduledAt) ? '✓ Jadwalkan Distribusi' : '✓ Setujui & Upload Sekarang'}
          </button>
          {selChannels.length === 0 ? (
            <div style={{ fontSize: 12, color: '#D97706', marginTop: 8 }}>
              Tombol nonaktif: ceklis minimal satu channel tujuan di atas dulu.
            </div>
          ) : !channelsSaved() && (
            <div style={{ fontSize: 12, color: '#6B7280', marginTop: 8 }}>
              {selChannels.length} channel diceklis — tersimpan otomatis saat kamu klik tombol ini.
            </div>
          )}
          {approveMsg && (
            <div style={{ padding: '9px 12px', marginTop: 10, borderRadius: 8, fontSize: 12.5,
              background: approveMsg.ok ? 'rgba(16,185,129,0.12)' : 'rgba(239,68,68,0.12)',
              color: approveMsg.ok ? '#059669' : '#DC2626' }}>{approveMsg.text}</div>
          )}
        </div>
      )}
      <div style={{ marginTop: 30, paddingTop: 16, borderTop: '1px solid #E5E7EB' }}>
        <button onClick={deleteProjectFull} disabled={deletingProject}
          style={{ padding: '8px 16px', background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.4)', color: '#DC2626', borderRadius: 8, cursor: 'pointer', fontSize: 12.5, fontWeight: 600 }}>
          {deletingProject ? 'Menghapus...' : '🗑️ Hapus Project (permanen)'}
        </button>
      </div>
    </div>
  );
}
